import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import BiotechOutlinedIcon from "@mui/icons-material/BiotechOutlined";
import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";
import MedicationOutlinedIcon from "@mui/icons-material/MedicationOutlined";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";
import {
  Box,
  Card,
  Container,
  Grid,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import moment from "moment";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import Chart from "react-apexcharts";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Custom3dotString from "../../../components/Custom3dotString";
import CustomButton from "../../../components/CustomButton";
import CustomCheckbox from "../../../components/CustomCheckbox";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../components/CustomTextField";
import CustomUpload from "../../../components/CustomUpload";
import Select from "../../../components/Select/Select";
import api from "../../../redux/actions/api";
import { createNewChat } from "../../../redux/reducers/chatSlice";
import {
  addFilesAndMemoForPetId,
  checkedCallInApi,
  checkedInApi,
  clinicReassignAppointment,
  getBillDetailsByPaymentId,
  getBillingListByPetId,
  getBillingsByCustomerId,
  getVitalTrendsByPetId,
  payToMultiplePaymentIds,
  setBillDetails,
  updateAppointmentStatusById,
  updateClinicUserById,
  updateClinicUserCollectionRefund,
  updateCompleted,
  updateFinalize,
  updateHospitalizationStatus,
} from "../../../redux/reducers/clinicSlice";
import { getMedicalHistoryByPetId } from "../../../redux/reducers/medicalHistorySlice";
import {
  addCoOwnerByPetId,
  getPetAndAppointmentDetailsById,
  getPetBreedsByType,
  getPetDetailsByIdNew,
  getPetTypes,
  updatePetById,
} from "../../../redux/reducers/petSlice";
import {
  assignTreatmentBundleToPet,
  getAllTreatmentBundlesByPetId,
  getTreatmentBundles,
} from "../../../redux/reducers/planSlice";
import { updateAppointmentStatus } from "../../../redux/reducers/vetSlice";
import { AppColors } from "../../../util/AppColors";
import { radioPaymentTypes } from "../../../util/arrayList";
import { a4PrintConfig } from "../../../util/commonConfig";
import {
  bloodGroups,
  genderList,
  reproductiveStatusFemaleList,
  reproductiveStatusMaleList,
  reproductiveStatusUnknownList,
  temperaments,
  UserPaymentTypeList,
} from "../../../util/dropList";
import { appointmentTypeEnum, tabEnum } from "../../../util/enum";
import { printFromNode, warmPrintFrame } from "../../../util/fastPrint";
import {
  getBorderColor,
  getDateFormat,
  getMonthsDifference,
  getPetShopRecordBasedType,
  getPharmacyRecordBasedType,
  getTotalEstimatedCost,
  getTypeByAppointmentType,
  reduceYearsAndMonthsToStartOfMonth,
} from "../../../util/function";
import { superTailsClinicId } from "../../../util/server";
import CreateClinicPet from "../../CommonComponents/CreateClinicPet";
import PaymentModeDropdown from "../../CommonComponents/PaymentModeDropdown";
import {
  getBillingFetchKey,
  setBillingFetchKey,
} from "../../Hospital/ClinicPetDetails/clinicPetDetailsSession";
import MedicalHistoryView from "../../Hospital/ClinicPetDetails/MedicalHistory/MedicalHistoryView";
import Allergies from "../../Hospital/ClinicPetDetails/PatientWorkbook/Allergies";
import FilesWithCloseButton from "../../Hospital/ClinicPetDetails/PatientWorkbook/FilesWithCloseButton";
import InternalNotes from "../../Hospital/ClinicPetDetails/PatientWorkbook/InternalNotes";
import InternalTags from "../../Hospital/ClinicPetDetails/PatientWorkbook/InternalTags";
import InpatientAdmitPatient from "../AdmitPatient/InpatientAdmitPatient";
import BillingPreview from "../BillingPreview/BillingPreview";
import BookAnAppointment from "../BookAppointmentment/BookAnAppointment";
import StatementOfAccounts, {
  buildSoaList,
} from "../Payments/StatementOfAccounts";
import ReminderDiagnostics from "../Reminder/ReminderDiagnostics";
import ReminderPreventive from "../Reminder/ReminderPreventive";
import ReminderProcedure from "../Reminder/ReminderProcedure";
import CerificatesDownloadModal from "./CerificatesDownloadModal";
import "./CommonClinicPetDetails.css";
import PetRemindersSidebar from "./PetRemindersSidebar";

const vitalTrendTabs = ["Temperature", "Weight"];

const getVitalTrendFieldKey = (tab) => {
  return tab === "Weight" ? "Body Weight" : "Body Temperature";
};

const initCoOwnValues = { name: "", email: "", mobile: "" };
const initCoOwnErrors = { name: false, email: false, mobile: false };

const requiredFields = [
  "petName",
  "dob",
  "breed",
  // "gender",
  // "reproductiveStatus",
  // "weight",
  "petType",
];
const initSOAValues = {
  visible: false,
  startDate: new Date(),
  endDate: new Date(),
  dateSelected: false,
  endDateErr: false,
};
const initCollectOutstandingValues = {
  invoiceNumber: [],
  amount: "",
  paymentMode: null,
  collectionDate: new Date(),
};

const CommonClinicPetDetails = ({
  children,
  upcomingVisible,
  isBaseDetailsLoaded,
  setVideoCallEnabled,
  appointment,
  scrollable = true,
  setSelectedTab,
  setInpatientId,
  allergyModOpen,
  setAllergyModOpen,
  selectedTab,
  setScrollable,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const contentToPrint = useRef(null);
  const [selectedHistory, setSelectedHistory] = useState(null);
  const [selectPet, setSelectPet] = useState(null);
  const [modalBookVisible, setBookModVisible] = useState(false);
  const [coOwnerModalVisible, setCoOwnerModalVisible] = useState(false);
  const [intrnalTagModVsble, setIntrnalTagModVsble] = useState(false);
  const [intrnalNoteModVsble, setIntrnalNoteModVsble] = useState(false);
  const [admitModVisible, setAdmitModVisible] = useState(false);
  const [vets, setVets] = useState([]);
  const [coOwnDetails, setCoOwnDetails] = useState(initCoOwnValues);
  const [coOwnErrors, setCoOwnErrors] = useState(initCoOwnErrors);
  const [disCofrmModVsble, setDisConfrmModVsble] = useState(false);
  const [createPetModVsble, setCreatePetModVsble] = useState(false);
  const [bundleModVsble, setBundleModVsble] = useState(false);
  const [isAddNewBundle, setAddNewBundle] = useState(false);
  const [selectedBundle, setSelectedBundle] = useState(null);
  const [sendToRecovery, setSendToRecovery] = useState(false);
  const [assignVetModVisible, setAssignVetModVisible] = useState(false);
  const [assignVetvalues, setAssignVetValues] = useState({});
  const [bundleSearchValue, setBundleSearchValue] = useState("");
  const [petModVsble, setPetModVsble] = useState(false);
  const [petValues, setPetValues] = useState({});
  const [errors, setErrors] = useState({});
  const [breedList, setBreedList] = useState([]);
  const [petTypeList, setPetTypeList] = useState([]);
  const [usrModVsble, setUsrModVsble] = useState(false);
  const [usrValues, setUsrValues] = useState({});
  const [usrErrs, setUsrErrs] = useState({});
  const [advancePayVsble, setAdvancePayModVsble] = useState(false);
  const [remModVsble, setRemModVsble] = useState(false);
  const [actTab, setActTab] = useState("preventive");
  const [presFilter, setPresFilter] = useState("Active");
  const [addVsble, setAddVsble] = useState(false);
  const [certModVsble, setCertModVsble] = useState(false);
  const [soaValues, setSOAValues] = useState(initSOAValues);
  const [petApptModVsble, setPetApptModVsble] = useState(false);
  const [customerSOAVsble, setCustomerSOAVsble] = useState(false);
  const [viewTreadsVsble, setViewTreadsVsble] = useState(false);
  const [selectedVitalTab, setSelectedVitalTab] = useState("Temperature");
  const [billPreviewModVsble, setBillPreviewModVsble] = useState(false);
  const [shortcutModVsble, setShortcutModVsble] = useState(false);
  const [shortcutFiles, setShortcutFiles] = useState([]);
  const [shortcutMemo, setShortcutMemo] = useState("");
  const [shortcutError, setShortcutError] = useState("");
  const [showOutstandingCollection, setShowOutstandingCollection] =
    useState(false);
  const [collectOutstandingValues, setCollectOutstandingValues] = useState(
    initCollectOutstandingValues,
  );
  const [collectOutstandingErrors, setCollectOutstandingErrors] = useState({});
  const clinicVets = useSelector((state) => state?.vet?.vets?.vets);
  const appData = useSelector((state) => state?.pet?.complaintSummary?.data);
  const { petDetails, petAppointments } = useSelector((state) => state?.pet);
  const petBilling = useSelector((state) => state?.clinic?.petAllBilling);
  const {
    details: clinicDetails,
    // facilities,
    petBillingList,
    billDetailsWoLoader,
    billDetails,
    cutomerBilling,
    vitalTrends,
  } = useSelector((state) => state?.clinic);
  const { treatmentBundles, petTreatmentBundles } = useSelector(
    (state) => state?.plan,
  );
  const petAndApntData = useSelector(
    (state) => state?.pet?.petAndAppointmentDetails,
  );
  const rightPetData = useSelector((state) => state?.pet?.petDetailsNew);
  const apntId =
    appointment?.appoinment?.appointmentId ??
    petAndApntData?.appointment?.appointmentId;
  const petId = appointment?.appoinment?.petId ?? petAndApntData?.pet?.petId;
  const userId = appointment?.appoinment?.userId ?? petAndApntData?.pet?.userId;
  const petData = petAndApntData?.pet;
  const apntDet = petAndApntData?.appointment ?? appointment?.appoinment;
  const inpatData = petAndApntData?.inpatientResponse ?? {};
  const statusActive =
    typeof petData?.status === "boolean"
      ? petData?.status
      : petData?.status === "Y";
  const user = localStorage.getItem("user");
  const profile = JSON.parse(user);
  const role = localStorage.getItem("role");
  const clinicDet = clinicDetails;
  const reqBillDetails =
    billDetails?.appointmentId === apntId ? billDetails : billDetailsWoLoader;
  const mandateDataRaw = sessionStorage.getItem("mandateData");
  const { facilities } = useMemo(() => {
    if (!mandateDataRaw) return { facilities: [] };
    try {
      const reqData = JSON.parse(mandateDataRaw);
      return {
        facilities: Array.isArray(reqData?.facilities)
          ? reqData?.facilities
          : [],
      };
    } catch {
      return { facilities: [] };
    }
  }, [mandateDataRaw]);

  // useEffect(() => {
  //   if (role === "ROLE_RADIOLOGY" && apntId) {
  //     getcompliantSummary(apntId);
  //   }
  // }, [role, apntId]);

  useEffect(() => {
    if (selectedTab !== "overView" || !userId || !isBaseDetailsLoaded) return;
    const fetchKey = `${userId}`;
    if (getBillingFetchKey() === fetchKey) return;
    setBillingFetchKey(fetchKey);
    // if (vets?.length === 0 || !vets)
    //   dispatch(getClinicVetsWoLoader("?type=all"));
    dispatch(getBillingsByCustomerId(userId));
    // dispatch(getPetBillingByIdAllWoLoader({ petId }));
  }, [selectedTab, userId, dispatch, isBaseDetailsLoaded]);

  useEffect(() => {
    const reqVetList = clinicVets
      ?.filter((vl) => {
        if (vl?.userType?.find((ut) => ut?.name === "ROLE_DOCTOR")) {
          return vl;
        }
      })
      ?.map((vet) => {
        return { name: vet?.name, value: vet?.doctorId, id: vet?.doctorId };
      });
    setVets(reqVetList);
  }, [clinicVets]);

  // useEffect(() => {
  //   if (
  //     apntId &&
  //     apntDet?.appointmentStatus === "finalize" &&
  //     appData?.paymentId &&
  //     role !== "ROLE_RADIOLOGY"
  //   ) {
  //     dispatch(getBillDetailsByPaymentIdWoLoader(appData?.paymentId));
  //   }
  // }, [appData, apntDet, apntId, role]);

  const getcompliantSummary = (apntIdParam = null) => {
    try {
      const safePetId = petId ?? selectPet?.petId ?? petData?.petId;
      if (!safePetId) return;

      const reqApntId = apntIdParam ?? apntId ?? apntDet?.appointmentId ?? null;
      const safeApntId =
        reqApntId != null && reqApntId !== "" ? reqApntId : null;

      dispatch(
        getPetAndAppointmentDetailsById({
          petId: safePetId,
          url: safeApntId ? `?appointmentId=${safeApntId}` : "",
        }),
      );
    } catch {
      // ignore refresh errors
    }
  };

  const onBookAppointmentCompleted = (status, bookedAppointment = null) => {
    try {
      if (status !== "Api Success") return;

      const currentApntId = apntId ?? apntDet?.appointmentId ?? null;
      if (currentApntId) return;

      const booked =
        bookedAppointment && typeof bookedAppointment === "object"
          ? bookedAppointment
          : null;
      const nestedData =
        booked?.data && typeof booked.data === "object" ? booked.data : null;
      const newApntId =
        booked?.appointmentId ?? nestedData?.appointmentId ?? null;

      getcompliantSummary(newApntId);
    } catch {
      // ignore booking completion refresh errors
    }
  };

  const bookAppointment = () => {
    setSelectPet(petData);
    setBookModVisible(true);
  };

  const openShortcutModal = () => {
    setShortcutFiles([]);
    setShortcutMemo("");
    setShortcutError("");
    setShortcutModVsble(true);
  };

  const onCloseShortcutModal = () => {
    setShortcutModVsble(false);
    setShortcutFiles([]);
    setShortcutMemo("");
    setShortcutError("");
  };

  const handleRemoveShortcutFile = (ind) => {
    setShortcutFiles((prev) => prev?.filter((_, i) => i !== ind));
    setShortcutError("");
  };

  const onUploadShortcutFile = (e) => {
    const fileList = e?.target?.files;
    let fileLists = shortcutFiles?.length > 0 ? [...shortcutFiles] : [];
    const readFiles = Array.from(fileList).map((file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          fileLists = [...fileLists, { file: file, previewUrl: reader.result }];
          resolve();
        };
        reader.onerror = () => reject(reader.error);
        reader.readAsDataURL(file);
      });
    });
    Promise.all(readFiles)
      .then(() => {
        setShortcutFiles(fileLists);
        setShortcutError("");
      })
      .catch((error) => console.error("Error reading files: ", error));
  };

  const handleShortcutSubmit = async () => {
    const hasMemo = !!shortcutMemo?.trim();
    const hasFiles = shortcutFiles?.length > 0;
    if (!hasMemo && !hasFiles) {
      setShortcutError("Please enter a memo or upload at least 1 file");
      return;
    }
    const form = new FormData();
    form.append("petId", petId);
    if (hasMemo) form.append("note", shortcutMemo?.trim());
    if (hasFiles) {
      const filePromises = shortcutFiles?.map(async (fle) => {
        if (fle?.file) {
          return fle?.file; // Local File
        }
      });
      const finalFiles = await Promise.all(filePromises);
      finalFiles?.forEach((file) => {
        form.append("files", file);
      });
    }
    dispatch(addFilesAndMemoForPetId(form)).then((res) => {
      if (res?.payload) onCloseShortcutModal();
    });
  };

  const vitalTrendChartData = useMemo(() => {
    const vitalFieldKey = getVitalTrendFieldKey(selectedVitalTab);

    return (vitalTrends ?? [])
      .map((item) => {
        const record = item?.data?.[0];
        if (!record) return null;

        const rawValue = record?.[vitalFieldKey];
        if (rawValue === undefined || rawValue === null || rawValue === "") {
          return null;
        }

        const value = Number(rawValue);
        if (Number.isNaN(value)) return null;

        return {
          vitalId: item?.vitalId,
          value,
          label: moment(item?.createdDate).format("DD MMM YYYY"),
          dateTime: moment(item?.createdDate).format("DD MMM YYYY, HH:mm"),
          createdDate: item?.createdDate,
        };
      })
      .filter(Boolean)
      .sort(
        (a, b) =>
          new Date(a.createdDate).getTime() - new Date(b.createdDate).getTime(),
      );
  }, [vitalTrends, selectedVitalTab]);

  const vitalTrendTooltipFormatter = useCallback(
    ({ dataPointIndex }) => {
      const item = vitalTrendChartData?.[dataPointIndex];
      if (!item) return "";

      const unit = selectedVitalTab === "Weight" ? "Kg" : "°F";

      return (
        '<div class="apexcharts-tooltip-title" style="font-family: Helvetica, Arial, sans-serif; font-size: 12px; background-color: #EBEBEB; color: #000; padding: 8px; margin: 0;">' +
        item.dateTime +
        '<span class="apexcharts-tooltip-marker" style="background-color: #0047AB; margin-left: 5px; width: 12px; height: 12px; border-radius: 2px; display: inline-block;"></span>' +
        "</div>" +
        '<div class="apexcharts-tooltip-series-group" style="order: 1; display: flex; background-color: #fff; padding: 8px;">' +
        '<div class="apexcharts-tooltip-text" style="font-family: Helvetica, Arial, sans-serif; font-size: 12px; color: #000;">' +
        '<div class="apexcharts-tooltip-y-group">' +
        '<span class="apexcharts-tooltip-text-y-label">' +
        selectedVitalTab +
        ": </span>" +
        '<span class="apexcharts-tooltip-text-y-value" style="font-weight: 600;">' +
        item.value +
        " " +
        unit +
        "</span>" +
        "</div>" +
        "</div>" +
        "</div>"
      );
    },
    [vitalTrendChartData, selectedVitalTab],
  );

  const vitalTrendChartOptions = useMemo(
    () => ({
      chart: { type: "line", toolbar: { show: false }, fontFamily: "inherit" },
      stroke: {
        width: 2,
        curve: "smooth",
      },
      markers: {
        size: 4,
        colors: ["#fff"],
        strokeColors: "#0047AB",
        strokeWidth: 2,
      },
      dataLabels: { enabled: false },
      xaxis: {
        categories: vitalTrendChartData.map((item) => item.dateTime),
        title: {
          text: "Date / Time",
          style: { fontSize: "12px", color: "#666", fontWeight: 500 },
        },
        labels: {
          style: { fontSize: "11px", colors: "#2C2C49", fontWeight: 500 },
          rotate: -35,
          hideOverlappingLabels: true,
        },
        axisBorder: { show: false },
        axisTicks: { show: false },
      },
      yaxis: {
        labels: {
          style: { fontSize: "12px", colors: "#2C2C49" },
          formatter: (val) => val,
        },
        title: {
          text: selectedVitalTab === "Weight" ? "Kg" : "°F",
          style: { fontSize: "12px", color: "#666", fontWeight: 500 },
        },
      },
      grid: {
        strokeDashArray: 4,
        borderColor: "#E9ECEF",
      },
      colors: ["#0047AB"],
      tooltip: {
        custom: vitalTrendTooltipFormatter,
      },
    }),
    [vitalTrendChartData, selectedVitalTab, vitalTrendTooltipFormatter],
  );

  const vitalTrendChartSeries = useMemo(
    () => [
      {
        name: selectedVitalTab,
        data: vitalTrendChartData.map((item) => item.value),
      },
    ],
    [vitalTrendChartData, selectedVitalTab],
  );

  const onViewTrends = () => {
    if (petId) dispatch(getVitalTrendsByPetId(petId));
    setViewTreadsVsble(true);
  };

  const openCoOwnerModal = () => {
    setCoOwnerModalVisible(true);
  };

  const openIntrnalTagModal = () => {
    setIntrnalTagModVsble(true);
  };

  const openIntrnalNotModal = () => {
    setIntrnalNoteModVsble(true);
  };

  const getAllClinicUserList = () => {
    const reqVetList =
      clinicVets
        ?.filter((vl) => vl?.status === "Y")
        ?.map((vet) => {
          return { name: vet?.name, value: vet?.doctorId, id: vet?.doctorId };
        }) ?? [];
    return reqVetList;
  };

  const getOthersByType = (type) => {
    const reqType = type === "Grooming" ? "ROLE_GROOMER" : "ROLE_RADIOLOGY";
    const reqVetList =
      clinicVets
        ?.filter((vl) => vl?.userRole === reqType)
        ?.map((vet) => {
          return { name: vet?.name, value: vet?.doctorId, id: vet?.doctorId };
        }) ?? [];
    return reqVetList;
  };

  const getVetList = () => {
    return clinicVets
      ?.filter((vl) => {
        if (vl?.userType?.find((ut) => ut?.name === "ROLE_DOCTOR")) {
          return vl;
        }
      })
      ?.map((vet) => {
        return { name: vet?.name, value: vet?.doctorId, id: vet?.doctorId };
      });
  };

  const checkIsVet = (apntVetId = null) => {
    if (!apntVetId) return false;
    return clinicVets?.some((li) =>
      li?.doctorId === apntVetId && li?.userType?.length > 0
        ? li?.userType?.some((ut) => ut?.name === "ROLE_DOCTOR")
        : false,
    );
  };

  const onCloseAssignVetMod = () => {
    setAssignVetModVisible(false);
    setAssignVetValues({});
  };

  const handleCallInApi = (
    vetId = null,
    facilityId = null,
    facilityName = null,
  ) => {
    const data = {
      appointmentId: apntDet?.appointmentId,
      doctorId: vetId ?? apntDet?.doctorId,
      facilityId,
      facilityName,
    };
    dispatch(checkedCallInApi(data)).then((res) => {
      if (res?.payload) {
        onCloseAssignVetMod();
        getcompliantSummary();
      }
    });
  };

  const callButtonApi = () => {
    if (apntDet?.appointmentType === "Virtual") {
      return handleJoinVideoCall();
    }
    if (apntDet?.appointmentStatus === "scheduled") {
      const data = {
        appointmentId: apntDet?.appointmentId,
        doctorId: apntDet?.doctorId,
      };
      dispatch(checkedInApi(data)).then((response) => {
        if (response?.payload) {
          getcompliantSummary();
        }
      });
    } else if (apntDet?.appointmentStatus === "inprogress") {
      if (
        (clinicDetails?.id === apntDet?.doctorId && !checkIsVet(profile?.id)) ||
        !apntDet?.facilityId
      ) {
        const reqVet =
          clinicDetails?.id === apntDet?.doctorId && !checkIsVet(profile?.id)
            ? null
            : clinicVets?.find(
                (vl) =>
                  vl?.doctorId ===
                  (checkIsVet(apntDet?.doctorId)
                    ? apntDet?.doctorId
                    : checkIsVet(profile?.id)
                      ? profile?.id
                      : null),
              );
        setAssignVetValues({
          vet:
            clinicDetails?.id === apntDet?.doctorId && !checkIsVet(profile?.id)
              ? null
              : {
                  name: reqVet?.name ?? apntDet?.doctorName,
                  value: reqVet?.doctorId ?? apntDet?.doctorId,
                  id: reqVet?.doctorId ?? apntDet?.doctorId,
                },
          facility: apntDet?.facilityId
            ? {
                name: apntDet?.facility ?? "",
                value: apntDet?.facilityId,
                id: apntDet?.facilityId,
              }
            : null,
        });
        setAssignVetModVisible(true);
        return;
      } else {
        handleCallInApi(
          checkIsVet(profile?.id) ? profile?.id : apntDet?.doctorId,
          apntDet?.facilityId,
          apntDet?.facility,
        );
      }
    } else if (apntDet?.appointmentStatus === "consultation") {
      dispatch(updateFinalize(apntDet?.appointmentId)).then((response) => {
        if (response?.payload) {
          getcompliantSummary();
        }
      });
    } else {
      dispatch(updateCompleted(apntDet?.appointmentId)).then((response) => {
        if (response?.payload) {
          if (
            profile?.createdBy === superTailsClinicId ||
            profile?.id === superTailsClinicId
          ) {
            dispatch(
              getMedicalHistoryByPetId({
                petId: apntDet?.petId,
                // url: `?type=all&page=1&itemSize=5`,
              }),
            ).then((res2) => {
              if (res2?.payload?.data) {
                setSelectedHistory(res2?.payload?.data?.[0]);
              }
            });
          }
          getcompliantSummary();
        }
      });
    }
  };

  const handleInTransitApi = (
    vetId = null,
    facilityId = null,
    facilityName = null,
  ) => {
    dispatch(
      updateAppointmentStatusById({
        appointmentId: apntDet?.appointmentId,
        status: "intransit",
        successMsg: "Patient has been notified!",
        url: `&facilityId=${facilityId}&facilityName=${facilityName}&doctorId=${vetId}`,
      }),
    ).then((res) => {
      if (res?.payload) {
        onCloseAssignVetMod();
        getcompliantSummary();
      }
    });
  };

  const callHomeBtnApi = () => {
    if (apntDet?.appointmentType === "Virtual") {
      return handleJoinVideoCall();
    }
    if (apntDet?.appointmentType === "Physical") {
      return callButtonApi();
    }
    let status = "scheduled";
    if (apntDet?.appointmentStatus === "scheduled") {
      if (
        (clinicDetails?.id === apntDet?.doctorId && !checkIsVet(profile?.id)) ||
        !apntDet?.facilityId
      ) {
        const reqVet =
          clinicDetails?.id === apntDet?.doctorId && !checkIsVet(profile?.id)
            ? null
            : clinicVets?.find(
                (vl) =>
                  vl?.doctorId ===
                  (checkIsVet(apntDet?.doctorId)
                    ? apntDet?.doctorId
                    : checkIsVet(profile?.id)
                      ? profile?.id
                      : null),
              );
        setAssignVetValues({
          vet:
            clinicDetails?.id === apntDet?.doctorId && !checkIsVet(profile?.id)
              ? null
              : {
                  name: reqVet?.name ?? apntDet?.doctorName,
                  value: reqVet?.doctorId ?? apntDet?.doctorId,
                  id: reqVet?.doctorId ?? apntDet?.doctorId,
                },
          facility: apntDet?.facilityId
            ? {
                name: apntDet?.facility ?? "",
                value: apntDet?.facilityId,
                id: apntDet?.facilityId,
              }
            : null,
        });
        setAssignVetModVisible(true);
        return;
      } else {
        handleInTransitApi(
          checkIsVet(profile?.id) ? profile?.id : apntDet?.doctorId,
          apntDet?.facilityId,
          apntDet?.facility,
        );
      }
      return;
    }
    if (apntDet?.appointmentStatus === "intransit") {
      status = "consultation";
    }
    if (apntDet?.appointmentStatus === "consultation") {
      status = "finalize";
    }
    if (apntDet?.appointmentStatus === "finalize") {
      status = "completed";
    }
    dispatch(
      updateAppointmentStatusById({
        appointmentId: apntDet?.appointmentId,
        status,
        successMsg:
          status === "intransit"
            ? "Patient has been notified!"
            : "Status updated successfully!",
      }),
    ).then((res) => {
      if (res?.payload) {
        if (
          (status === "completed" &&
            profile?.createdBy === superTailsClinicId) ||
          profile?.id === superTailsClinicId
        ) {
          dispatch(
            getMedicalHistoryByPetId({
              petId: apntDet?.petId,
              // url: `?type=all&page=1&itemSize=5`,
            }),
          ).then((res2) => {
            if (res2?.payload?.data) {
              setSelectedHistory(res2?.payload?.data?.[0]);
            }
          });
        }
        // if (clinicDetails?.id !== apntDet?.doctorId) {
        //   getcompliantSummary(apntDet?.appointmentId);
        // }
      }
    });
  };

  const handleJoinVideoCall = () => {
    setVideoCallEnabled(true);
    if (navigator.mediaDevices.getUserMedia !== null) {
      var options = {
        video: true,
        audio: true,
      };
      navigator.getUserMedia(options, function (e) {
        console.log("background error : " + e.name);
      });
    }
    if (apntDet?.appointmentStatus?.toLowerCase() === "scheduled") {
      dispatch(
        updateAppointmentStatus({
          appId: apntDet?.appointmentId,
          status: "inprogress",
        }),
      );
    }
  };

  const onCloseAdmitModal = (val) => {
    if (val === "Api Success") {
      if (sendToRecovery) {
        dispatch(
          updateAppointmentStatusById({
            appointmentId: apntDet?.appointmentId,
            status: "recovery",
            successMsg: "Status updated successfully!",
          }),
        )?.then((res) => {
          if (res?.payload) getcompliantSummary(apntDet?.appointmentId);
        });
      } else {
        getcompliantSummary(apntDet?.appointmentId);
      }
    }
    setAdmitModVisible(false);
    setSendToRecovery(false);
  };

  const handleDischarge = () => {
    setDisConfrmModVsble(true);
  };

  const handleCoOwnModClose = () => {
    setCoOwnDetails(initCoOwnValues);
    setCoOwnErrors(initCoOwnErrors);
    setCoOwnerModalVisible(false);
  };

  const handleCoOwnChange = (name, value) => {
    setCoOwnDetails({ ...coOwnDetails, [name]: value });
    setCoOwnErrors({ ...coOwnErrors, [name]: value !== "" ? false : true });
  };

  const handleValidation = () => {
    let errs = {};
    Object.keys(coOwnDetails).forEach((det) => {
      if (coOwnDetails?.[det] === "") {
        errs = { ...errs, [det]: true };
      }
    });
    setCoOwnErrors({ ...coOwnErrors, ...errs });
    return Object.keys(errs).length > 0 ? false : true;
  };

  const handleSaveCoOwner = async () => {
    const validated = handleValidation();
    if (!validated) return;
    const data = {
      name: coOwnDetails?.name,
      email: coOwnDetails?.email,
      mobile: coOwnDetails?.mobile,
    };
    dispatch(addCoOwnerByPetId({ petId: petData?.petId, data })).then((res) => {
      if (res?.payload) {
        handleCoOwnModClose();
        getcompliantSummary(apntDet?.appointmentId);
      }
    });
  };

  const handleCloseDisCnfrm = () => {
    setDisConfrmModVsble(false);
  };

  const handleConfirmDischarge = () => {
    dispatch(
      updateAppointmentStatusById({
        appointmentId: apntDet?.appointmentId,
        status: "finalize",
        successMsg: "Status updated successfully!",
      }),
    ).then((res) => {
      if (res?.payload) {
        handleCloseDisCnfrm();
        getcompliantSummary(apntDet?.appointmentId);
      }
    });
  };

  const onCloseCreateMod = (e) => {
    if (e === "petCreated") {
      dispatch(getPetDetailsByIdNew(petId));
    }
    setCreatePetModVsble(false);
  };

  const handleChat = () => {
    dispatch(
      createNewChat(apntId ? appData?.pet?.userId : petDetails?.userId),
    ).then((res) => {
      if (res?.payload) {
        navigate("/chat", { state: { chatId: res?.payload?.chatId } });
      }
    });
  };

  const getAllOutstandingBlance = () => {
    return cutomerBilling?.data?.length > 0
      ? cutomerBilling?.data
          // ?.filter((li) => (li?.status ?? "")?.toLowerCase() !== "paid")
          ?.reduce(
            (acc, obj) => acc + Number(obj?.balanceDue ?? 0),
            //  obj?.balanceDue
            0,
          )
      : 0;
  };

  const handleBundleSelect = () => {
    dispatch(getAllTreatmentBundlesByPetId(petId ?? petDetails?.petId));
    setBundleModVsble(true);
  };

  const handleBundleclose = () => {
    setSelectedBundle(null);
    setBundleModVsble(false);
    setAddNewBundle(false);
    setBundleSearchValue("");
  };

  const handleAddBundle = () => {
    dispatch(getTreatmentBundles());
    setAddNewBundle(true);
  };

  const handleAssign = () => {
    if (
      (selectedBundle?.treatmentId ?? selectedBundle?.bundleId) &&
      (petId ?? petDetails?.petId)
    ) {
      dispatch(
        assignTreatmentBundleToPet({
          treatmentId: selectedBundle?.treatmentId ?? selectedBundle?.bundleId,
          petId: petId ?? petDetails?.petId,
        }),
      ).then((res) => {
        if (res?.payload) {
          handleBundleclose();
        }
      });
    }
  };

  const handleEditPet = () => {
    const isDateDob = (petData?.dobType ?? "").toLowerCase() === "date";
    const reqObj = {
      petId: petData?.petId,
      dobType: isDateDob ? "date" : "age",
      ageType: "Month",
      dob: isDateDob
        ? (petData?.dob ?? null)
        : getMonthsDifference(petData?.dob),
      petType: null,
      breed: null,
      petName: petData?.petName,
      color: petData?.color,
      gender: petData?.gender,
      reproductiveStatus: petData?.reproductiveStatus,
      weight: petData?.weight,
      rfid: petData?.rfid,
      bloodGroup:
        petData?.bloodGroup?.length > 0
          ? { name: petData?.bloodGroup, value: petData?.bloodGroup }
          : null,
      temperament:
        petData?.temperament?.length > 0
          ? { name: petData?.temperament, value: petData?.temperament }
          : null,
      image: { file: null, previewUrl: petData?.petImage ?? null },
    };
    dispatch(getPetTypes()).then((res) => {
      if (res?.payload) {
        const reqList = res?.payload?.map((sp) => ({
          name: sp?.speciesName,
          value: sp?.speciesName,
          id: sp?.speciesId,
        }));
        reqObj.petType =
          reqList?.find(
            (sp) =>
              (sp?.name ?? "")?.toLowerCase() ===
              (petData?.petType ?? "")?.toLowerCase(),
          ) ?? null;
        setPetTypeList(reqList);
        if (reqObj?.petType?.id) {
          dispatch(getPetBreedsByType(reqObj?.petType?.id)).then((res2) => {
            if (res2?.payload) {
              const reqList = res2?.payload?.map((bd) => ({
                ...bd,
                name: bd?.breedName,
                value: bd?.breedName,
              }));
              reqObj.breed = reqList?.find(
                (bd) =>
                  bd?.value?.toLowerCase() === petData?.breed?.toLowerCase(),
              );
              setBreedList(reqList);
            }
          });
        }
      }
    });

    setPetValues(reqObj);
    setPetModVsble(true);
  };

  const petModClose = () => {
    setPetModVsble(false);
    setPetValues({});
    setErrors({});
  };

  const handleEditUser = () => {
    setUsrValues({
      userName: petData?.userName,
      userMobile: petData?.userMobile,
      address: petData?.address,
      email: petData?.userEmail,
      petId: petData?.petId,
      secondaryMobile: petData?.secondaryMobile ?? "",
    });
    setUsrModVsble(true);
  };

  const usrModClose = () => {
    setUsrModVsble(false);
    setUsrValues({});
    setUsrErrs({});
  };

  const handleValueChange = (value, name) => {
    const reqValue = typeof value === "object" ? value?.value : value;
    const valObj = { ...usrValues, [name]: value };
    if (name === "paymentType") {
      valObj.paymentMode = null;
    }
    setUsrValues(valObj);
    const errObj = {
      ...usrErrs,
      [name]:
        reqValue?.length > 0
          ? ""
          : name === "email"
            ? ""
            : "This field is required",
    };

    if (name === "advanceAmount") {
      if (Number(value) <= 0) {
        errObj.advanceAmount = "Amount should be greater than 0";
      } else if (
        Number(value) > Number(petData?.advanceAmount ?? 0) &&
        usrValues?.paymentType === "Refund"
      ) {
        errObj.advanceAmount = "Insufficient credit balance";
      } else {
        errObj.advanceAmount = "";
      }
    }
    setUsrErrs(errObj);
  };

  const onUploadFile = (e) => {
    const reader = new FileReader();
    const file = e?.target?.files[0];
    reader.onloadend = () => {
      setPetValues({
        ...petValues,
        image: { file: e.target.files[0], previewUrl: reader.result },
      });
    };
    reader.readAsDataURL(file);
  };

  const handlePetValueChange = (value, name) => {
    if (name === "dobType") {
      setPetValues({ ...petValues, dobType: value, dob: null });
      setErrors((prevErrors) => ({ ...prevErrors, dob: "", [name]: "" }));
      return;
    }

    const reqObj = { ...petValues, [name]: value };
    if (name === "petType") {
      reqObj.breed = null;
      dispatch(getPetBreedsByType(value?.id)).then((res) => {
        if (res?.payload) {
          const reqList = res?.payload?.map((bd) => ({
            ...bd,
            name: bd?.breedName,
            value: bd?.breedName,
          }));
          setBreedList(reqList);
        }
      });
    }
    setPetValues(reqObj);

    let fieldError = "";
    if (requiredFields?.includes(name)) {
      if (name === "dob") {
        if ((petValues?.dobType ?? "age") === "date") {
          fieldError = value ? "" : "This field is required";
        } else {
          const age = value;
          fieldError =
            age === null ||
            age === undefined ||
            age === "" ||
            Number.isNaN(Number(age)) ||
            Number(age) <= 0
              ? "This field is required"
              : "";
        }
      } else {
        const reqValue =
          typeof value === "object" ? value?.value?.toString() : value;
        fieldError = reqValue?.length > 0 ? "" : "This field is required";
      }
    }
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: fieldError,
    }));
  };

  const getFormattedDob = () => {
    if ((petValues?.dobType ?? "age") === "date") {
      if (!petValues?.dob) return "";
      return getDateFormat(petValues.dob);
    }
    return reduceYearsAndMonthsToStartOfMonth({
      years: petValues?.ageType === "Year" ? Number(petValues?.dob) : 0,
      months: petValues?.ageType === "Month" ? Number(petValues?.dob) : 0,
    });
  };

  const validateFields = () => {
    let errObj = {};
    requiredFields?.forEach((key) => {
      if (key === "dob") {
        if ((petValues?.dobType ?? "age") === "date") {
          if (!petValues?.dob) {
            errObj.dob = "This field is required";
          }
        } else {
          const age = petValues?.dob;
          if (
            age === null ||
            age === undefined ||
            age === "" ||
            Number.isNaN(Number(age)) ||
            Number(age) <= 0
          ) {
            errObj.dob = "This field is required";
          }
        }
        return;
      }
      const reqValue =
        typeof petValues?.[key] === "object"
          ? petValues?.[key]?.value
          : petValues?.[key];
      if (reqValue?.length === 0 || !reqValue) {
        errObj = { ...errObj, [key]: "This field is required" };
      }
    });
    const clearedRequired = Object.fromEntries(
      (requiredFields ?? []).map((key) => [key, ""]),
    );
    setErrors({ ...errors, ...clearedRequired, ...errObj });
    return Object.keys(errObj).length > 0;
  };

  const updatePet = () => {
    if (validateFields()) return;
    const form = new FormData();
    if (petData?.ownershipType) {
      form.append("ownershipType", petData?.ownershipType);
    }
    form.append("petName", petValues?.petName);
    form.append("petType", petValues?.petType?.value);
    form.append("breed", petValues?.breed?.value);
    form.append("weight", petValues?.weight);
    form.append("reproductiveStatus", petValues?.reproductiveStatus);
    form.append("gender", petValues?.gender);
    form.append("dob", getFormattedDob());
    form.append("dobType", petValues?.dobType ?? "age");
    form.append("color", petValues?.color);
    if (petValues?.image?.file) form.append("petImage", petValues?.image?.file);
    if (petValues?.rfid?.length > 0) form.append("rfid", petValues?.rfid);
    if (petValues?.bloodGroup?.value?.length > 0)
      form.append("bloodGroup", petValues?.bloodGroup?.value);
    if (petValues?.temperament?.value?.length > 0)
      form.append("temperament", petValues?.temperament?.value);
    dispatch(updatePetById({ petId: petValues?.petId, form })).then((res) => {
      if (res?.payload) {
        getcompliantSummary(apntId);
        petModClose();
      }
    });
  };

  const updateUser = () => {
    if (
      usrValues?.userName?.length === 0 ||
      !usrValues?.userName ||
      usrValues?.userMobile?.length === 0 ||
      !usrValues?.userMobile ||
      !petData?.userId
    ) {
      let errs = { ...usrErrs };
      if (usrValues?.userName?.length === 0 || !usrValues?.userName) {
        errs = { ...errs, userName: "This field is required" };
      }
      if (usrValues?.userMobile?.length === 0 || !usrValues?.userMobile) {
        errs = { ...errs, userMobile: "This field is required" };
      }
      setUsrErrs(errs);
      return;
    }
    const form = new FormData();
    form.append("userName", usrValues?.userName);
    form.append("userMobile", usrValues?.userMobile);
    // form.append("advanceAmount", 0);
    if (usrValues?.email?.length > 0) {
      form.append("email", usrValues?.email ?? "");
    }
    // if (usrValues?.address?.length > 0) {
    form.append("address", usrValues?.address ?? "");
    // }
    // if (usrValues?.secondaryMobile?.length > 0) {
    form.append("secondaryMobile", usrValues?.secondaryMobile ?? "");
    // }
    dispatch(updateClinicUserById({ userId: petData?.userId, form })).then(
      (res) => {
        if (res?.payload) {
          getcompliantSummary(apntId);
          usrModClose();
        }
      },
    );
  };

  const handleCollectAdvance = () => {
    setUsrValues({
      paymentType: radioPaymentTypes?.[0]?.value,
      userName: petData?.userName,
      userMobile: petData?.userMobile,
      email: petData?.userEmail,
      petId: petData?.petId,
      paymentMode: UserPaymentTypeList?.[0],
      reason: "",
    });
    setAdvancePayModVsble(true);
  };

  const handleClosePayMod = () => {
    setAdvancePayModVsble(false);
    setUsrValues({});
    setUsrErrs({});
  };

  const handlePay = () => {
    if (
      usrValues?.advanceAmount?.length === 0 ||
      !usrValues?.advanceAmount ||
      !usrValues?.paymentMode ||
      (usrValues?.paymentType === "Refund" &&
        Number(usrValues?.advanceAmount) >
          Number(petData?.advanceAmount ?? 0)) ||
      Number(usrValues?.advanceAmount) <= 0
    ) {
      const errs = {};
      if (!usrValues?.paymentMode) errs.paymentMode = "This field is required";
      if (usrValues?.advanceAmount?.length === 0 || !usrValues?.advanceAmount) {
        errs.advanceAmount = "This field is required";
      } else if (usrValues?.advanceAmount <= 0) {
        errs.advanceAmount = "Amount should be greater than 0";
      } else if (
        usrValues?.paymentType === "Refund" &&
        Number(usrValues?.advanceAmount) > Number(petData?.advanceAmount ?? 0)
      ) {
        errs.advanceAmount = "Insufficient credit balance";
      } else {
        errs.advanceAmount = "";
      }
      setUsrErrs(errs);
      if (Object.keys(errs)?.length > 0) return;
    }
    const form = new FormData();
    form.append("userName", usrValues?.userName);
    form.append("userMobile", usrValues?.userMobile);
    if (
      usrValues?.paymentType === "Collect" &&
      petData?.petName &&
      petData?.petId
    ) {
      form.append("petName", petData?.petName);
      form.append("petId", petData?.petId);
    }
    if (usrValues?.email?.length > 0) {
      form.append("email", usrValues?.email);
    }
    if (usrValues?.address?.length > 0) {
      form.append("address", usrValues?.address);
    }
    if (usrValues?.secondaryMobile?.length > 0) {
      form.append("secondaryMobile", usrValues?.secondaryMobile);
    }
    form.append("paymentType", usrValues?.paymentType);
    form.append(
      "advanceAmount",
      Number(
        `${usrValues?.paymentType === "Collect" ? "+" : "-"}${
          usrValues?.advanceAmount
        }`,
      ),
    );
    form.append("reason", usrValues?.reason ?? "");
    form.append("paymentMode", usrValues?.paymentMode?.value);
    dispatch(
      updateClinicUserCollectionRefund({
        userId: petData?.userId,
        form,
        successMsg: "Payment updated successfully!",
      }),
    ).then((res) => {
      if (res?.payload) {
        getcompliantSummary(apntId);
        handleClosePayMod();
      }
    });
  };

  const handleClickPet = (pet) => {
    // if (pet?.appointmentId) {
    //   dispatch(getPetsCompliantSummary(pet?.appointmentId));
    // } else if (pet?.petId) {
    //   dispatch(getPetDetailsById(pet?.petId));
    // }
    return navigate("/clinic-pet-details", {
      state: {
        appointment: {
          appoinment: {
            appointmentId: pet?.appointmentId ?? null,
            petId: pet?.petId,
            userId: pet?.userId,
          },
        },
        inpatientId: pet?.inpaitentId,
      },
    });
  };

  const handleUploadComplete = async (url, apntId) => {
    await api({ contentType: true, auth: true })
      .get(`/appointment/${apntId}`)
      .then(async (getRes) => {
        if (getRes?.status === 200 || getRes?.status === 201) {
          if (getRes?.data?.data) {
            const reqObj = {
              appointment: {
                ...getRes?.data?.data,
                // caseSummary: url
              },
            };
            try {
              // await superTailsApi.post("/appointment-completed", reqObj);
              setSelectedHistory(null);
            } catch (supErr) {
              console.log("SuperTail Api Error", supErr);
            }
          }
        }
      });
  };

  const onCloseRemMod = () => {
    setRemModVsble(false);
  };

  const onClickAdd = () => {
    setAddVsble(true);
  };

  const onChangeTab = (tab) => {
    setActTab(tab);
    setAddVsble(false);
  };

  const onCloseCertMod = () => {
    setCertModVsble(false);
  };

  const onAssignVetChange = (name, value, errName) => {
    setAssignVetValues({
      ...assignVetvalues,
      [name]: value,
      [errName]: value?.value ? false : true,
    });
  };

  const getFacilitiesByType = (type) => {
    const reqType =
      apntDet?.appointmentType === "Home"
        ? "HomeKit"
        : type === "Surgery"
          ? "OperationTheatre"
          : type === "Consultation" ||
              type === "Lab Tests" ||
              type === "Radiology Tests" ||
              type === "Others"
            ? "ConsultationRoom"
            : "BathBays";
    const reqVetList =
      facilities
        ?.filter((fl) => fl?.type?.toLowerCase() !== "devices")
        // ?.filter((fl) => fl?.type === reqType)
        ?.map((fl) => {
          return { name: fl?.name, value: fl?.facilityId, id: fl?.facilityId };
        }) ?? [];
    return reqVetList;
  };

  const onAssignVet = () => {
    if (!assignVetvalues?.vet?.value || !assignVetvalues?.facility?.value) {
      return setAssignVetValues({
        ...assignVetvalues,
        error: !assignVetvalues?.vet?.value,
        facilityErr: !assignVetvalues?.facility?.value,
      });
    }
    if (apntDet?.inpatient) {
      updateAppointmentStatusByAppointment({
        status: "insurgery",
        successMsg: "Status updated successfully!",
        isReassign: true,
        facilityId: assignVetvalues?.facility?.value,
        facilityName: assignVetvalues?.facility?.name,
        doctorId: assignVetvalues?.vet?.value,
      });
      return;
    }
    if (apntDet?.appointmentType === "Home") {
      handleInTransitApi(
        assignVetvalues?.vet?.value,
        assignVetvalues?.facility?.value,
        assignVetvalues?.facility?.name,
      );
    } else {
      handleCallInApi(
        assignVetvalues?.vet?.value,
        assignVetvalues?.facility?.value,
        assignVetvalues?.facility?.name,
      );
    }
  };

  const updateAppointmentStatusByAppointment = ({
    status,
    isReassign = false,
    successMsg = "Status updated successfully!",
    facilityId = null,
    facilityName = null,
    doctorId = null,
  }) => {
    dispatch(
      updateAppointmentStatusById({
        appointmentId: apntDet?.appointmentId,
        status,
        successMsg,
      }),
    ).then((res) => {
      if (res?.payload) {
        if (isReassign) {
          const reAssignValues = { facilityId, facilityName, doctorId };
          dispatch(
            clinicReassignAppointment({
              appointmentId: apntDet?.appointmentId,
              data: reAssignValues,
            }),
          )?.then((apiRes) => {
            if (apiRes?.payload) {
              onCloseAssignVetMod();
              getcompliantSummary();
              return;
            }
          });
        } else {
          getcompliantSummary();
        }
      }
    });
  };

  const onClickInpatientBtn = () => {
    if (apntDet?.appointmentStatus === "scheduled") {
      if (
        (clinicDetails?.id === apntDet?.doctorId && !checkIsVet(profile?.id)) ||
        !apntDet?.facilityId
      ) {
        const reqVet =
          clinicDetails?.id === apntDet?.doctorId && !checkIsVet(profile?.id)
            ? null
            : clinicVets?.find(
                (vl) =>
                  vl?.doctorId ===
                  (checkIsVet(apntDet?.doctorId)
                    ? apntDet?.doctorId
                    : checkIsVet(profile?.id)
                      ? profile?.id
                      : null),
              );
        setAssignVetValues({
          vet:
            clinicDetails?.id === apntDet?.doctorId && !checkIsVet(profile?.id)
              ? null
              : {
                  name: reqVet?.name ?? apntDet?.doctorName,
                  value: reqVet?.doctorId ?? apntDet?.doctorId,
                  id: reqVet?.doctorId ?? apntDet?.doctorId,
                },
          facility: apntDet?.facilityId
            ? {
                name: apntDet?.facility ?? "",
                value: apntDet?.facilityId,
                id: apntDet?.facilityId,
              }
            : null,
        });
        setAssignVetModVisible(true);
        return;
      } else {
        const reqVet =
          clinicDetails?.id === apntDet?.doctorId && !checkIsVet(profile?.id)
            ? null
            : clinicVets?.find(
                (vl) =>
                  vl?.doctorId ===
                  (checkIsVet(apntDet?.doctorId)
                    ? apntDet?.doctorId
                    : checkIsVet(profile?.id)
                      ? profile?.id
                      : null),
              );
        updateAppointmentStatusByAppointment({
          status: "insurgery",
          successMsg: "Status updated successfully!",
          isReassign: true,
          facilityId: apntDet?.facilityId,
          facilityName: apntDet?.facility,
          doctorId: reqVet?.doctorId ?? apntDet?.doctorId,
        });
      }
    }
    if (apntDet?.appointmentStatus?.toLowerCase() === "insurgery") {
      setSendToRecovery(true);
      setAdmitModVisible(true);
    }
    if (
      apntDet?.appointmentStatus?.toLowerCase() === "recovery" &&
      !appData?.inpatient?.hospitalization
    ) {
      setSendToRecovery(false);
      setAdmitModVisible(true);
    }
    if (
      apntDet?.appointmentStatus?.toLowerCase() === "recovery" &&
      appData?.inpatient?.hospitalization
    ) {
      dispatch(
        updateHospitalizationStatus({
          patientId: inpatData?.patientId,
          status: false,
        }),
      ).then((res) => {
        if (res?.payload) {
          dispatch(
            updateAppointmentStatusById({
              appointmentId: apntDet?.appointmentId,
              status: "scheduled",
              successMsg: "Status updated successfully!",
            }),
          ).then((res2) => {
            if (res2?.payload) {
              getcompliantSummary();
            }
          });
        }
      });
    }
  };

  const isCheckoutDisabled =
    apntDet?.appointmentStatus === "finalize" &&
    ((clinicDetails?.billingMode ?? "")?.toLowerCase() === "separate"
      ? apntDet?.checkOut !== "Y" ||
        ((getPharmacyRecordBasedType(reqBillDetails?.paymentDetails)?.length >
          0 ||
          Number(reqBillDetails?.pharmacyAmtPaid ?? 0) > 0) &&
          apntDet?.pharmacyCheckout !== "Y") ||
        ((getPetShopRecordBasedType(reqBillDetails?.paymentDetails)?.length >
          0 ||
          Number(reqBillDetails?.petShopAmtPaid ?? 0) > 0) &&
          apntDet?.petShopCheckout !== "Y")
      : apntDet?.checkOut !== "Y");

  const onClickSOA = () => {
    setSOAValues({ ...soaValues, visible: true });
  };

  const onCloseSOAMod = () => {
    setSOAValues(initSOAValues);
  };

  const onChangeSOAValue = (name, value) => {
    const reqObj = { ...soaValues, [name]: value };
    setSOAValues(reqObj);
  };

  const onClickProceed = () => {
    const data = {
      page: 1,
      itemSize: 1000,
      startDate: moment(new Date(soaValues?.startDate)).format("YYYY-MM-DD"),
      endDate: moment(new Date(soaValues?.endDate)).format("YYYY-MM-DD"),
    };
    dispatch(getBillingListByPetId({ petId: petData?.petId, data }));
    setSOAValues({ ...soaValues, dateSelected: true });
  };

  const getPaymentCollections = () => {
    return (petBillingList?.data ?? [])?.flatMap(
      (li) => li?.paymentCollections ?? [],
    );
  };

  const getDepositSummaryList = () => {
    return (petBillingList?.data ?? [])?.flatMap(
      (li) => li?.depositCollections ?? [],
    );
  };

  const soaList = useMemo(
    () => buildSoaList(petBillingList?.data ?? []),
    [petBillingList?.data],
  );

  useEffect(() => {
    if (
      !soaValues?.visible ||
      !soaValues?.dateSelected ||
      typeof window === "undefined"
    )
      return;
    let cancelled = false;
    const warm = () => {
      if (cancelled) return;
      const node = contentToPrint?.current;
      if (node) warmPrintFrame(node, a4PrintConfig);
    };
    const frameId = requestAnimationFrame(warm);
    const node = contentToPrint?.current;
    const imgs = node ? [...node.querySelectorAll("img")] : [];
    imgs.forEach((img) => {
      if (!img.complete) {
        img.addEventListener("load", warm, { once: true });
        img.addEventListener("error", warm, { once: true });
      }
    });
    return () => {
      cancelled = true;
      cancelAnimationFrame(frameId);
      imgs.forEach((img) => {
        img.removeEventListener("load", warm);
        img.removeEventListener("error", warm);
      });
    };
  }, [soaValues?.visible, soaValues?.dateSelected, soaList]);

  const handlePrint = () => {
    printFromNode(contentToPrint?.current, {
      title: `SOA_${Date.now()}`,
      pageStyle: a4PrintConfig,
    });
  };

  const getReqAppointments = () => {
    return (petAppointments ?? [])?.filter(
      (apnt) =>
        apnt?.appointmentId !== apntId &&
        !["finalize", "completed", "cancelled"]?.includes(
          (apnt?.appointmentStatus ?? "")?.toLowerCase(),
        ),
    );
  };

  const onClickAppointment = (apnt) => {
    // if (apnt?.appointmentId) {
    //   dispatch(getPetsCompliantSummary(apnt?.appointmentId));
    // } else if (petId) {
    //   dispatch(getPetDetailsById(petId));
    // }
    const openPatientWorkbook =
      ["consultation", "finalize"].includes(
        apnt?.appointmentStatus?.toLowerCase(),
      ) ||
      (apnt?.appointmentType === "Virtual" &&
        apnt?.appointmentStatus?.toLowerCase() === "inprogress");
    navigate(`/clinic-pet-details`, {
      state: {
        appointment: {
          appoinment: {
            appointmentId: apnt?.appointmentId,
            petId,
            userId,
          },
        },
        selectedTab: openPatientWorkbook ? "patientWorkbook" : "overview",
      },
    });
    setPetApptModVsble(false);
  };

  const onViewCustomerSOA = () => {
    setCustomerSOAVsble(true);
  };

  const getCustomerDueSOA = () => {
    return cutomerBilling?.data?.filter(
      (li) => Number(li?.balanceDue ?? 0) > 0,
    );
  };

  const onOpenCollectOutstanding = () => {
    setCollectOutstandingValues({
      ...initCollectOutstandingValues,
      customer: { name: petData?.userName ?? "", value: userId },
      invoiceNumber: [
        {
          name: "All",
          value: "All",
          total: 0,
          advanceAmount: petData?.advanceAmount ?? 0,
        },
      ],
      amount: Number(Number(getAllOutstandingBlance()).toFixed(2)),
    });
    setCollectOutstandingErrors({});
    // if (userId) {
    //   dispatch(getBillingsByCustomerId(userId));
    // }
    setShowOutstandingCollection(true);
  };

  const onCloseCollectOutstanding = () => {
    setShowOutstandingCollection(false);
    setCollectOutstandingValues(initCollectOutstandingValues);
    setCollectOutstandingErrors({});
  };

  const getOutstandingInvoiceList = () => {
    const dueList = getCustomerDueSOA() ?? [];
    const reqList = dueList.map((li) => ({
      name: `${li?.invoiceNumber ?? ""}, ₹${Number(li?.balanceDue ?? 0).toFixed(2)}, ${moment(li?.date).format("DD MMM YYYY")}`,
      value: (li?.paymentId ?? "")?.toString(),
      paymentId: li?.paymentId,
      invoiceNo: li?.invoiceNumber ?? "",
      total: Number(li?.balanceDue ?? 0),
      advanceAmount: petData?.advanceAmount ?? 0,
      type: li?.type,
      checkOut: li?.checkOut,
    }));

    return [
      {
        name: "All",
        value: "All",
        total: 0,
        advanceAmount: petData?.advanceAmount ?? 0,
      },
      ...(reqList ?? [])?.filter((li) => li?.total > 0),
    ];
  };

  const isAllInvoiceOption = (li) =>
    (li?.value ?? "")?.toString()?.toLowerCase() === "all";

  const getResolvedOutstandingInvoices = (selected = []) => {
    const list = Array.isArray(selected) ? selected : [];
    const nonAll = list.filter((li) => !isAllInvoiceOption(li));
    if (list.some(isAllInvoiceOption) && nonAll.length === 0) {
      return getOutstandingInvoiceList().filter(
        (li) => !isAllInvoiceOption(li),
      );
    }
    return nonAll;
  };

  const onChangeCollectOutstanding = (name, value) => {
    const reqValue = typeof value === "object" ? value?.value : value;
    const reqObj = { ...collectOutstandingValues, [name]: value };
    const errs = {
      ...collectOutstandingErrors,
      [name]:
        (typeof reqValue === "number" ? reqValue?.toString() : reqValue)
          ?.length > 0
          ? ""
          : "This field is required",
    };

    if (name === "invoiceNumber") {
      const prevValue = Array.isArray(collectOutstandingValues?.invoiceNumber)
        ? collectOutstandingValues.invoiceNumber
        : [];
      const newValue = Array.isArray(value) ? value : [];
      const prevHadAll = prevValue.some(isAllInvoiceOption);
      const newHasAll = newValue.some(isAllInvoiceOption);
      const newNonAll = newValue.filter((li) => !isAllInvoiceOption(li));

      let reqList;
      if (newHasAll && !prevHadAll) {
        reqList = [{ name: "All", value: "All" }];
      } else if (newHasAll && prevHadAll && newNonAll.length > 0) {
        reqList = newNonAll;
      } else if (newHasAll) {
        reqList = [{ name: "All", value: "All" }];
      } else {
        reqList = newValue;
      }

      reqObj.invoiceNumber = reqList;
      reqObj.amount = Number(
        Number(
          getResolvedOutstandingInvoices(reqList)
            ?.reduce((acc, obj) => acc + (Number(obj?.total ?? 0) ?? 0), 0)
            ?.toFixed(2),
        ),
      );
      errs.invoiceNumber =
        (reqList ?? [])?.length > 0 ? "" : "This field is required";
      errs.amount =
        Number(
          Number(
            getResolvedOutstandingInvoices(reqList)
              ?.reduce((acc, obj) => acc + (Number(obj?.total ?? 0) ?? 0), 0)
              ?.toFixed(2),
          ),
        ) > 0
          ? ""
          : "This field is required";
    }

    if (name === "amount") {
      const amount = Number(value);
      const selectedInvoices = getResolvedOutstandingInvoices(
        collectOutstandingValues?.invoiceNumber,
      );
      const totalBalanceDue = selectedInvoices?.reduce(
        (acc, obj) => acc + (Number(obj?.total ?? 0) ?? 0),
        0,
      );
      const isAdvanceAdjustment =
        collectOutstandingValues?.paymentMode?.value === "Advance Adjustment";
      const availableAdvance = Number(
        selectedInvoices?.[0]?.advanceAmount ?? petData?.advanceAmount ?? 0,
      );

      if (
        value === "" ||
        value == null ||
        (typeof value === "string" && value.trim() === "") ||
        isNaN(amount)
      ) {
        errs.amount = "This field is required";
      } else if (amount <= 0) {
        errs.amount = "Amount must be positive";
      } else if (isAdvanceAdjustment && amount > availableAdvance) {
        errs.amount = "Insufficient credit balance";
      } else if (amount > totalBalanceDue) {
        errs.amount = "Amount must be less than or equal to balance due";
      } else {
        errs.amount = "";
      }
    }

    setCollectOutstandingErrors(errs);
    setCollectOutstandingValues(reqObj);
  };

  const onClickCollectOutstandingPay = () => {
    const selectedInvoices = getResolvedOutstandingInvoices(
      collectOutstandingValues?.invoiceNumber,
    );
    const totalBalanceDue = selectedInvoices?.reduce(
      (acc, obj) => acc + (Number(obj?.total ?? 0) ?? 0),
      0,
    );
    const amount = Number(collectOutstandingValues?.amount);
    const isAdvanceAdjustment =
      collectOutstandingValues?.paymentMode?.value === "Advance Adjustment";
    const availableAdvance = Number(
      selectedInvoices?.[0]?.advanceAmount ?? petData?.advanceAmount ?? 0,
    );

    let amountErr = "";
    if (
      !collectOutstandingValues?.amount ||
      collectOutstandingValues?.amount?.toString()?.trim() === "" ||
      isNaN(amount)
    ) {
      amountErr = "This field is required";
    } else if (amount <= 0) {
      amountErr = "Amount must be positive";
    } else if (isAdvanceAdjustment && amount > availableAdvance) {
      amountErr = "Insufficient credit balance";
    } else if (amount > totalBalanceDue) {
      amountErr = "Amount must be less than or equal to balance due";
    }

    let errs = {
      amount: amountErr,
      paymentMode: !collectOutstandingValues?.paymentMode?.value
        ? "This field is required"
        : "",
      invoiceNumber:
        (collectOutstandingValues?.invoiceNumber ?? [])?.length === 0
          ? "This field is required"
          : "",
    };

    if (Object.values(errs).some((item) => item?.length > 0)) {
      return setCollectOutstandingErrors(errs);
    }
    if (selectedInvoices?.length === 0) {
      return;
    }
    const reqDate = moment(
      new Date(collectOutstandingValues?.collectionDate ?? new Date()),
    ).format("YYYY-MM-DDTHH:mm:ss");
    let remainingAmount = amount;
    const invoiceList = selectedInvoices
      ?.sort((a, b) => a?.paymentId - b?.paymentId)
      ?.reduce((acc, bil) => {
        if (remainingAmount <= 0) return acc;

        const balanceDue = Number(bil?.total ?? 0);
        if (balanceDue <= 0) return acc;

        const paymentAmount =
          balanceDue <= remainingAmount ? balanceDue : remainingAmount;
        remainingAmount -= paymentAmount;

        acc.push({
          paymentId: bil?.paymentId,
          mode: collectOutstandingValues?.paymentMode?.value ?? "",
          amount: Number(paymentAmount ?? 0),
          tabName: tabEnum?.[bil?.type],
          invoiceNo: bil?.invoiceNo ?? "",
          status: bil?.checkOut === "Y" ? "APPLIED" : "UNAPPLIED",
          paymentDate: reqDate,
        });
        return acc;
      }, []);

    if (invoiceList?.length === 0) {
      return;
    }
    dispatch(payToMultiplePaymentIds(invoiceList)).then((res) => {
      if (res?.payload) {
        onCloseCollectOutstanding();
        if (userId) {
          dispatch(getBillingsByCustomerId(userId));
        }
        if (petId) {
          dispatch(getPetDetailsByIdNew(petId));
        }
      }
    });
  };

  const onViewBill = (paymentId) => {
    if (paymentId) dispatch(getBillDetailsByPaymentId(paymentId));
    setBillPreviewModVsble(true);
  };

  return (
    <>
      <Grid container className="back-white ph20">
        <Grid
          item
          xs={12}
          sm={12}
          md={2.5}
          lg={2.5}
          xl={2.5}
          className="back-white border-rt"
        >
          <div className="scroll-90vh">
            <Container maxWidth="xl" className="ph10 mt15">
              <div className="shadow-card br8 pt10 pb10 pr15 pl15">
                <Typography className="flex-end mb10">
                  <Typography className="fs11 bg-blue-100 clr-blue txt-semi-bold br20 pt3 pb3 pl10 pr10 mr10">
                    {petData?.petType}
                  </Typography>
                </Typography>
                <div className="display-flex just-start ali-start gap4">
                  {petData?.petImage ? (
                    <img src={petData?.petImage} alt="" className="img40" />
                  ) : (
                    <div className="flex-center imghw40 br50Per gray-back">
                      <Typography className="font-bold fs30 white-color capitalize">
                        {petData?.petName?.[0]}
                      </Typography>
                    </div>
                  )}
                  <div className="flex-column ml10">
                    <div className="flex-row">
                      <div className="flex-center">
                        <Custom3dotString
                          str={petData?.petName}
                          className="font-bold fs14"
                        />

                        <Typography
                          className={`ml5 txt-semi-bold fs14 capitalize ${
                            petData?.gender === "male"
                              ? "card-blue-color"
                              : "card-rose-color"
                          }`}
                        >
                          {`(${petData?.gender ?? ""})`}
                        </Typography>
                      </div>
                    </div>
                    <Typography className="txt-regular fs11">
                      {petData?.breed} -{" "}
                      {(() => {
                        const dob = petData?.dob ?? location?.state?.pet?.dob;
                        const years = moment().diff(moment(dob), "years");
                        if (years > 0) return `${years} yrs`;
                        const months = moment().diff(moment(dob), "months");
                        if (months > 0) return `${months} months`;
                        const days = moment().diff(moment(dob), "days");
                        return `${days} days`;
                      })()}{" "}
                      - {petData?.weight} KG
                    </Typography>
                    <Typography className="txt-regular fs11">
                      Colour: {petData?.color ?? ""}
                    </Typography>
                  </div>
                </div>

                <p className="bottomHr mv10" />

                <div>
                  <div className="flex-row-between-align-center mb3">
                    <div className="fs11 txt-semi-bold clr-muted">CUSTOMER</div>
                    <div
                      className="fs11 txt-semi-bold clr-muted cursor"
                      onClick={handleEditUser}
                    >
                      Edit
                    </div>
                  </div>

                  <Typography className="mb3 font-medium clr-dark-gray fs11">
                    {petData?.userName}
                  </Typography>
                  <Typography className="mb3 font-medium clr-dark-gray fs11">
                    {petData?.userEmail} · {petData?.userMobile ?? ""}
                  </Typography>
                  {petData?.secondaryMobile?.length > 0 ? (
                    <Typography className="mb3 font-medium clr-dark-gray fs11">
                      {petData?.secondaryMobile}
                    </Typography>
                  ) : null}
                  <div className="flex-row-ali-cen">
                    <Typography className="font-medium clr-dark-gray fs11">
                      App status:{" "}
                    </Typography>
                    <Typography className="ml10 fs10 bg-blue-100 clr-blue txt-regular br20 pt3 pb3 pl10 pr10">
                      {petAndApntData?.intsalled
                        ? "Installed"
                        : "Not Installed"}
                    </Typography>
                  </div>
                </div>
                <p className="bottomHr mv10" />
                {petAndApntData?.coOwners?.length > 0 &&
                  petAndApntData?.coOwners?.slice(0, 1)?.map((own, i) => (
                    <div className="">
                      <div className="d-flex align-items-center justify-content-between gap-2">
                        <p className="mb3 fs11 txt-semi-bold clr-muted">
                          CO-CUSTOMER
                        </p>
                        {petAndApntData?.coOwners?.length > 0 ? null : (
                          <Typography
                            className="fs20 font-medium cursor"
                            onClick={openCoOwnerModal}
                          >
                            {" "}
                            +
                          </Typography>
                        )}
                      </div>

                      <Typography className="mb3 font-medium clr-dark-gray fs11">
                        <Custom3dotString
                          str={own?.name}
                          className="font-medium clr-dark-gray fs11"
                          length={15}
                        />
                      </Typography>
                      <Typography className="font-medium clr-dark-gray fs11">
                        {own?.email} · {own?.mobile}
                      </Typography>
                    </div>
                  ))}
              </div>

              <div className="flex-row-ali-cen mv10">
                <div>
                  <CustomButton
                    text="Chat"
                    leftIcon
                    startIcon={<ChatOutlinedIcon />}
                    onClick={handleChat}
                  />
                </div>
                {(apntDet?.appointmentStatus === "finalize" ||
                  !apntDet?.inpatient) &&
                  apntId &&
                  (apntDet?.appointmentStatus === "scheduled" ||
                  apntDet?.appointmentStatus === "inprogress" ||
                  // apntDet?.appointmentStatus === "consultation" ||
                  apntDet?.appointmentStatus === "finalize" ||
                  apntDet?.appointmentStatus === "intransit" ? (
                    //  ||
                    // apntDet?.appointmentType === "Virtual"
                    <div className="ml10">
                      <CustomButton
                        text={`${
                          apntDet?.appointmentType === "Virtual" &&
                          apntDet?.appointmentStatus !== "completed"
                            ? "Join Call"
                            : apntDet?.appointmentType === "Physical"
                              ? apntDet?.appointmentStatus === "scheduled"
                                ? "Check-in"
                                : apntDet?.appointmentStatus === "inprogress"
                                  ? "Call-in"
                                  : apntDet?.appointmentStatus ===
                                      "consultation"
                                    ? "End Consult" //"Finalize"
                                    : "Checkout"
                              : //handled home visit btn
                                apntDet?.appointmentType === "Home"
                                ? apntDet?.appointmentStatus === "scheduled"
                                  ? "In Transit"
                                  : apntDet?.appointmentStatus === "intransit"
                                    ? "In Consult"
                                    : apntDet?.appointmentStatus ===
                                        "consultation"
                                      ? "End Consult" //"Finalize"
                                      : "Checkout"
                                : ""
                        }`}
                        onClick={() => {
                          apntDet?.appointmentType === "Virtual"
                            ? handleJoinVideoCall()
                            : apntDet?.appointmentType === "Home"
                              ? callHomeBtnApi()
                              : callButtonApi();
                        }}
                        disabled={isCheckoutDisabled}
                        grayBtn={isCheckoutDisabled}
                        smallBtn
                      />
                    </div>
                  ) : null)}
                {apntDet?.inpatient &&
                (apntDet?.appointmentStatus?.toLowerCase() === "scheduled" ||
                  apntDet?.appointmentStatus?.toLowerCase() === "insurgery" ||
                  // (apntDet?.appointmentStatus?.toLowerCase() === "recovery" &&
                  //   !appData?.inpatient?.hospitalization) ||
                  (apntDet?.appointmentStatus?.toLowerCase() === "recovery" &&
                    appData?.inpatient?.hospitalization)) ? (
                  <div className="ml10">
                    <CustomButton
                      text={`${
                        apntDet?.appointmentStatus?.toLowerCase() ===
                        "scheduled"
                          ? "Call-in"
                          : apntDet?.appointmentStatus?.toLowerCase() ===
                              "insurgery"
                            ? "Send To Recovery"
                            : // : apntDet?.appointmentStatus?.toLowerCase() ===
                              //     "recovery" &&
                              //   !appData?.inpatient?.hospitalization
                              // ? "Admit"
                              apntDet?.appointmentStatus?.toLowerCase() ===
                                  "recovery" &&
                                appData?.inpatient?.hospitalization
                              ? "Send To Surgery"
                              : ""
                      }`}
                      onClick={() => {
                        onClickInpatientBtn();
                      }}
                      // disabled={
                      //   apntDet?.appointmentStatus === "finalize" &&
                      //   apntDet?.checkOut !== "Y"
                      // }
                      // grayBtn={
                      //   apntDet?.appointmentStatus === "finalize" &&
                      //   apntDet?.checkOut !== "Y"
                      // }
                      smallBtn
                    />
                  </div>
                ) : null}
              </div>

              <div className="mb10">
                <PetRemindersSidebar
                  onOpenReminders={() => setRemModVsble(true)}
                  apntId={apntId}
                />
              </div>

              <div className="mb3 uppercase clr-muted fs11 txt-semi-bold">
                Shortcuts
              </div>

              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <div className="flex-row cursor">
                  <div
                    className="p5 br5 flex-start w100Per white-blue-hvr"
                    onClick={handleEditPet}
                  >
                    <Typography className="fs13 blue-color font-medium">
                      Edit Profile
                    </Typography>
                  </div>
                </div>
                <div className="flex-row cursor">
                  <div
                    className="p5 br5 flex-start w100Per white-blue-hvr"
                    onClick={onViewTrends}
                  >
                    <Typography className="fs13 blue-color font-medium">
                      Vital Trends
                    </Typography>
                  </div>
                </div>

                {statusActive ? (
                  <>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <div className="flex-row cursor">
                        <div
                          className="p5 br5 flex-start w100Per white-blue-hvr"
                          onClick={bookAppointment}
                        >
                          <Typography className="fs13 blue-color font-medium">
                            Book an appointment
                          </Typography>
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <div className="flex-row cursor">
                        <div
                          className="p5 br5 flex-start w100Per white-blue-hvr"
                          onClick={openShortcutModal}
                        >
                          <Typography className="fs13 blue-color font-medium">
                            Memo/Records
                          </Typography>
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <div className="flex-row cursor">
                        <div
                          className="p5 br5 flex-start w100Per white-blue-hvr"
                          onClick={onClickSOA}
                        >
                          <Typography className="fs13 blue-color font-medium">
                            SOA
                          </Typography>
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <div className="flex-row cursor">
                        <div
                          className="p5 br5 flex-start w100Per white-blue-hvr"
                          onClick={() => setRemModVsble(true)}
                        >
                          <Typography className="fs13 blue-color font-medium">
                            Reminders
                          </Typography>
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <div className="flex-row cursor">
                        <div
                          className="p5 br5 flex-start w100Per white-blue-hvr"
                          onClick={() => setCertModVsble(true)}
                        >
                          <Typography className="fs13 blue-color font-medium">
                            Certificates
                          </Typography>
                        </div>
                      </div>
                    </Grid>
                  </>
                ) : null}

                {apntDet?.inpatient &&
                inpatData?.hospitalization &&
                !["finalize", "completed"].includes(
                  apntDet?.appointmentStatus?.toLowerCase(),
                ) ? (
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <div className="flex-row cursor" onClick={handleDischarge}>
                      <div className="p5 br5 flex-start w100Per white-blue-hvr">
                        <Typography className="fs13 blue-color font-medium">
                          Discharge Patient
                        </Typography>
                      </div>
                    </div>
                  </Grid>
                ) : (apntDet?.inpatient &&
                    !inpatData?.hospitalization &&
                    apntDet?.appointmentStatus?.toLowerCase() ===
                      "scheduled") ||
                  ["virtual", "home"].includes(
                    apntDet?.appointmentType?.toLowerCase(),
                  ) ||
                  [
                    "finalize",
                    "completed",
                    "canceled",
                    "cancelled",
                    "pending",
                  ].includes(apntDet?.appointmentStatus?.toLowerCase()) ||
                  !apntId ? null : (
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <div
                      className="flex-row cursor"
                      onClick={() => setAdmitModVisible(true)}
                    >
                      <div className="p5 br5 flex-start w100Per white-blue-hvr">
                        <Typography className="fs13 blue-color font-medium">
                          Admit Patient
                        </Typography>
                      </div>
                    </div>
                  </Grid>
                )}
                {statusActive ? (
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <div className="flex-row cursor">
                      <div
                        className="p5 br5 flex-start w100Per white-blue-hvr"
                        onClick={handleCollectAdvance}
                      >
                        <Typography className="fs13 blue-color font-medium">
                          Collect/Refund
                        </Typography>
                      </div>
                    </div>
                  </Grid>
                ) : null}
              </Grid>

              {/*
              <Grid container className="mb20 mt10">                
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  className="mt10"
                >
                  <Typography className="text-bold mb10 fs14">
                    Shortcuts
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <div className="flex-row mv5 cursor">
                    <EditIcon className="lef-icon" />
                    <div className="ml10 flex-center" onClick={handleEditPet}>
                      <Typography className="txt-regular fs14">
                        Edit Profile
                      </Typography>
                    </div>
                  </div>
                </Grid>
                {statusActive ? (
                  <>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <div className="flex-row mv5 cursor">
                        <CalendarMonthOutlinedIcon className="lef-icon" />
                        <div
                          className="ml10 flex-center"
                          onClick={bookAppointment}
                        >
                          <Typography className="txt-regular fs14">
                            Book an appointment
                          </Typography>
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <div className="flex-row mv5 cursor">
                        <WorkHistoryIcon className="lef-icon" />
                        <div className="ml10 flex-center" onClick={onClickSOA}>
                          <Typography className="txt-regular fs14">
                            SOA
                          </Typography>
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <div className="flex-row mv5 cursor">
                        <EventAvailableIcon className="lef-icon" />
                        <div
                          className="ml10 flex-center"
                          onClick={() => setRemModVsble(true)}
                        >
                          <Typography className="txt-regular fs14">
                            Reminders
                          </Typography>
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <div className="flex-row mv5 cursor">
                        <CardMembershipIcon className="lef-icon" />
                        <div
                          className="ml10 flex-center"
                          onClick={() => setCertModVsble(true)}
                        >
                          <Typography className="txt-regular fs14">
                            Certificates
                          </Typography>
                        </div>
                      </div>
                    </Grid>
                  </>
                ) : null}                
                {apntDet?.inpatient &&
                appData?.inpatient?.hospitalization &&
                apntDet?.appointmentStatus?.toLowerCase() !== "finalize" &&
                apntDet?.appointmentStatus?.toLowerCase() !== "completed" ? (
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <div
                      className="flex-row mv5 cursor"
                      onClick={handleDischarge}
                    >
                      <BookmarkRemoveIcon className="lef-icon" />
                      <div className="ml10 flex-center">
                        <Typography className="txt-regular fs14">
                          Discharge Patient
                        </Typography>
                      </div>
                    </div>
                  </Grid>
                ) : (apntDet?.inpatient &&
                    !appData?.inpatient?.hospitalization &&
                    apntDet?.appointmentStatus?.toLowerCase() ===
                      "scheduled") ||
                  apntDet?.appointmentType?.toLowerCase() === "virtual" ||
                  apntDet?.appointmentType?.toLowerCase() === "home" ||
                  apntDet?.appointmentStatus?.toLowerCase() === "finalize" ||
                  apntDet?.appointmentStatus?.toLowerCase() === "completed" ||
                  apntDet?.appointmentStatus?.toLowerCase() === "canceled" ||
                  apntDet?.appointmentStatus?.toLowerCase() === "cancelled" ||
                  apntDet?.appointmentStatus?.toLowerCase() === "pending" ||
                  !apntId ? null : (
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <div
                      className="flex-row mv5 cursor"
                      onClick={() => setAdmitModVisible(true)}
                    >
                      <MedicationIcon className="lef-icon" />
                      <div className="ml10 flex-center">
                        <Typography className="txt-regular fs14">
                          Admit Patient
                        </Typography>
                      </div>
                    </div>
                  </Grid>
                )}
                {statusActive ? (
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <div className="flex-row mv5 cursor">
                      <img
                        src={require("../../../assets/images/png/collectAdvance.png")}
                        className="lef-icon"
                      />
                      <div
                        className="ml10 flex-center"
                        onClick={handleCollectAdvance}
                      >
                        <Typography className="txt-regular fs14">
                          Collect/Refund
                        </Typography>
                      </div>
                    </div>
                  </Grid>
                ) : null}                
              </Grid> */}
            </Container>
          </div>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={upcomingVisible ? 7 : 9.5}
          lg={upcomingVisible ? 7 : 9.5}
          xl={upcomingVisible ? 7 : 9.5}
          className={`${upcomingVisible ? "border-rt" : ""} ${
            scrollable ? "scrollable-content" : ""
          }`}
        >
          {/* <Container maxWidth="xl"> */}
          {children}
          {/* </Container> */}
        </Grid>
        {upcomingVisible ? (
          <Grid
            item
            xs={12}
            sm={12}
            md={2.5}
            lg={2.5}
            xl={2.5}
            className="back-white"
          >
            <div
            // className="scroll-90vh"
            >
              <Grid container className="mv15 ph10">
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <div className="shadow-card br8 pt10 pb10 pr15 pl15">
                    <div className="flex-row-between">
                      <div className="flex-row-ali-cen">
                        <Typography className="txt-semi-bold fs11 clr-dark-gray">
                          Active Appointments
                        </Typography>
                        <Typography className="txt-semi-bold fs11 red-color ml3">
                          ({getReqAppointments()?.length ?? 0})
                        </Typography>
                      </div>
                      <Typography
                        className="fs10 font-medium clr-dark-gray cursor underline"
                        onClick={() => setPetApptModVsble(true)}
                      >
                        Show All
                      </Typography>
                    </div>
                  </div>

                  <div className="mt15 shadow-card br8 pt10 pb10 pr15 pl15">
                    <div className="flex-row-between">
                      <Typography className="txt-semi-bold fs11 clr-dark-gray">
                        Internal Tags
                      </Typography>
                      <Typography
                        className="fs10 font-medium clr-dark-gray cursor"
                        onClick={openIntrnalTagModal}
                      >
                        Edit
                      </Typography>
                    </div>
                    {rightPetData?.petInternalTags?.length > 0 && (
                      <div className="flex-row-wrap1">
                        {rightPetData?.petInternalTags?.map((tg) => (
                          <div
                            className="flex-row-ali-cen pv5 ph10 cursor br15 mh5 mv5"
                            style={{ background: tg?.color }}
                            key={tg?.internalId}
                          >
                            <Typography className="font-bold fs10 white-color">
                              {tg?.tags}
                            </Typography>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>

                  <div className="mt15 shadow-card br8 pt10 pb10 pr15 pl15">
                    <div className="flex-row-between">
                      <Typography className="txt-semi-bold fs11 clr-dark-gray">
                        Internal Notes
                      </Typography>
                      <Typography
                        className="fs10 font-medium clr-dark-gray cursor"
                        onClick={openIntrnalNotModal}
                      >
                        Edit
                      </Typography>
                    </div>
                    <div className="mt10 ">
                      <Typography className="txt-regular fs11">
                        -----
                      </Typography>
                    </div>
                  </div>

                  <div className="mt15 shadow-card br8 pt10 pb10 pr15 pl15">
                    <div className="flex-row-between">
                      <Typography className="txt-semi-bold fs11 clr-dark-gray">
                        Billing
                      </Typography>
                      <div>
                        <div className="flex-row-ali-cen">
                          <Typography
                            className="fs10 font-medium clr-dark-gray cursor viewBtn"
                            onClick={onViewCustomerSOA}
                          >
                            View
                          </Typography>
                        </div>
                      </div>
                    </div>
                    <div className="mt10">
                      <div>
                        <Typography className="font-bold fs12 red-color">
                          Outstanding:{" "}
                          {(Number(getAllOutstandingBlance()) ?? 0 > 0)
                            ? `Rs ${Number(getAllOutstandingBlance()).toFixed(2)}`
                            : "Nil"}
                        </Typography>
                        <Typography className="mt5 font-bold fs12 green-color">
                          Credits:{" "}
                          {Number(petData?.advanceAmount)
                            ? `Rs ${Number(petData?.advanceAmount).toFixed(2)}`
                            : "Nil"}
                        </Typography>
                      </div>
                    </div>
                  </div>

                  <div className="mt15 shadow-card br8 pt10 pb10 pr15 pl15">
                    <div className="flex-row-between-align-center">
                      <Typography className="txt-semi-bold fs11 clr-dark-gray">
                        Other Pets
                      </Typography>
                      <Typography
                        className="fs20 font-medium clr-dark-gray cursor"
                        onClick={() => setCreatePetModVsble(true)}
                      >
                        +
                      </Typography>
                    </div>
                    <div className="mt10">
                      <Typography className="txt-regular fs11">
                        <div className="flex-row scrollx">
                          {rightPetData?.otherPets?.length > 0 &&
                            rightPetData?.otherPets
                              ?.filter((pet) => pet?.petId !== petData?.petId)
                              ?.map((pet, i) => (
                                <div
                                  key={i + pet?.petId}
                                  className="mh10 cursor"
                                  onClick={() => handleClickPet(pet)}
                                >
                                  {pet?.petImage ? (
                                    <img
                                      src={pet?.petImage}
                                      alt=""
                                      className="img3 img3mhmw"
                                    />
                                  ) : (
                                    <div className="flex-center h50img">
                                      <Typography className="font-bold fs30 white-color capitalize">
                                        {pet?.petName?.[0]}
                                      </Typography>
                                    </div>
                                  )}
                                  <Custom3dotString
                                    str={pet?.petName}
                                    className="fs12 mt5 txt-semi-bold flex-center gray4"
                                    length={6}
                                  />
                                </div>
                              ))}
                        </div>
                      </Typography>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </div>
          </Grid>
        ) : null}
        {modalBookVisible ? (
          <BookAnAppointment
            modalVisible={modalBookVisible}
            setBookModVisible={setBookModVisible}
            selectedPet={selectPet ?? petData ?? null}
            onBookModalCompleted={onBookAppointmentCompleted}
          />
        ) : null}
        {selectedTab === "overView" && role !== "ROLE_RADIOLOGY" ? (
          <>
            <InternalTags
              intrnalTagModVsble={intrnalTagModVsble}
              setIntrnalTagModVsble={setIntrnalTagModVsble}
              updatedApp={apntDet}
              appoinment={appointment}
            />
            <InternalNotes
              intrnalNoteModVsble={intrnalNoteModVsble}
              setIntrnalNoteModVsble={setIntrnalNoteModVsble}
              updatedApp={apntDet}
              appoinment={appointment}
            />

            <Allergies
              allergyModOpen={allergyModOpen}
              setAllergyModOpen={setAllergyModOpen}
              updatedApp={apntDet}
              appointment={appointment}
            />
          </>
        ) : null}
      </Grid>
      {createPetModVsble ? (
        <CreateClinicPet
          createModVisible={createPetModVsble}
          onCloseCreateMod={onCloseCreateMod}
          userDetails={{
            id: petData?.userId,
            email: petData?.userEmail,
            name: petData?.userName,
            mobile: petData?.userMobile,
          }}
          selectedStep={1}
        />
      ) : null}

      {selectedHistory ? (
        <MedicalHistoryView
          selectedHistory={selectedHistory}
          petData={petData}
          onUploadComplete={(e, apntId) => handleUploadComplete(e, apntId)}
        />
      ) : null}

      <CustomModal
        open={petApptModVsble}
        onClose={() => setPetApptModVsble(false)}
        header={`Active Appointments (${getReqAppointments()?.length ?? 0})`}
        rightModal
        modalWidth={30}
      >
        <div className="scroll-85vh ph15">
          {getReqAppointments()?.map((apnt) => {
            return (
              <div
                className="pat-top-con light-blue-back4 ph10 pv10 w100Per mv10 br10 cursor"
                key={apnt?.appointmentId}
                onClick={() => onClickAppointment(apnt)}
              >
                <div className="flex-row-ali-cen">
                  <Typography className="fs12 blue-color font-bold">
                    Case ID - {apnt?.caseId}
                  </Typography>
                  <Typography className="blue-color fs12 font-medium ml15">
                    {apnt?.serviceType}
                  </Typography>
                  <Typography className="blue-color fs12 font-bold ml15">
                    {moment(new Date(apnt?.appointmentdateTime)).format(
                      "DD MMM YYYY, HH:mm",
                    )}
                  </Typography>
                </div>
                <div className="flex-row-ali-cen mt5">
                  <Typography className="blue-color fs12 txt-semi-bold">
                    {/* {getRightSaluation(clinicVets, apnt?.doctorId)} */}
                    Dr. {apnt?.doctorName}
                  </Typography>
                  <Typography
                    className={`txt-regular white-color fs12 upcom-app-box con-fit ml15 ${
                      apnt?.appointmentType === "Physical"
                        ? "card-con-blue-back"
                        : "virtual-bg-color"
                    }`}
                  >
                    {appointmentTypeEnum?.[apnt?.appointmentType]}
                  </Typography>
                  <Typography
                    className={`ml15 txt-regular white-color fs12 upcom-app-box ${
                      apnt?.appointmentStatus?.toLowerCase() === "canceled" ||
                      apnt?.appointmentStatus?.toLowerCase() === "cancelled"
                        ? "card-con-red-back"
                        : apnt?.appointmentStatus?.toLowerCase() === "completed"
                          ? "card-con-green-back"
                          : apnt?.appointmentStatus?.toLowerCase() ===
                                "consultation" ||
                              apnt?.appointmentStatus?.toLowerCase() ===
                                "finalize"
                            ? "card-top-yellow-color"
                            : "card-top-orange-color"
                    }`}
                  >
                    {getTypeByAppointmentType(apnt?.appointmentStatus)}
                  </Typography>
                </div>
              </div>
            );
          })}
        </div>
      </CustomModal>

      <CustomModal
        open={soaValues?.visible}
        onClose={onCloseSOAMod}
        header="Statement of Accounts"
        modal
        modalWidth={soaValues?.dateSelected ? 80 : 30}
        headerBold
      >
        <div className={`${soaValues?.dateSelected ? "scroll-70vh" : ""} ph20`}>
          <div>
            {!soaValues?.dateSelected ? (
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Typography className="font-medium fs14 black">
                    Start Date
                  </Typography>
                  <CustomTextField
                    mobileDate
                    fullWidth
                    value={soaValues?.startDate}
                    name="startDate"
                    handleChange={(e) =>
                      onChangeSOAValue("startDate", e?.target?.value)
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Typography className="font-medium fs14 black">
                    End Date
                  </Typography>
                  <CustomTextField
                    mobileDate
                    fullWidth
                    value={soaValues?.endDate}
                    name="endDate"
                    handleChange={(e) =>
                      onChangeSOAValue("endDate", e?.target?.value)
                    }
                  />
                </Grid>
                <div className="flex1-end mv20">
                  <div>
                    <CustomButton
                      text="Proceed"
                      smallBtn
                      onClick={onClickProceed}
                    />
                  </div>
                </div>
              </Grid>
            ) : null}
            {soaValues?.dateSelected ? (
              <StatementOfAccounts
                ref={contentToPrint}
                clinicDet={clinicDet}
                petName={petData?.petName}
                userName={petData?.userName}
                startDate={soaValues?.startDate}
                endDate={soaValues?.endDate}
                soaList={soaList}
                onPrint={handlePrint}
                showEmptyMessage={false}
              />
            ) : null}
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={customerSOAVsble}
        onClose={() => setCustomerSOAVsble(false)}
        header="Outstanding (Due)"
        modal
        modalWidth={30}
        headerBold
      >
        <div className="scroll-80vh-new ph10">
          {getCustomerDueSOA()?.length > 0 ? (
            <>
              {getCustomerDueSOA()?.map((li) => (
                <div key={li?.paymentId}>
                  <div className="flex-row mt5">
                    <div className="w70Per">
                      <div className="fs12 font-medium">
                        {li?.invoiceNumber ?? ""}
                      </div>
                      <div className="fs10 font-medium">
                        {li?.petName ?? ""}
                      </div>
                      <div className="fs10 font-medium">
                        {moment(li?.date).format("DD MMM YYYY")}
                      </div>
                    </div>
                    <div className="w30Per flex1-end">
                      <div>
                        <div className="fs12 font-medium">
                          {Number(li?.balanceDue ?? 0)?.toFixed(2)}
                        </div>
                        <div className="flex1-end">
                          <Typography
                            className="fs10 font-medium underline blue-color cursor"
                            onClick={() => onViewBill(li?.paymentId)}
                          >
                            View
                          </Typography>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="gry-hor-split3" />
                </div>
              ))}
              <div className="blk-hor-split mt5" />
              <div className="flex-row-between-align-center mv5">
                <Typography className="font-bold fs12 red-color mv5">
                  Total due:{" "}
                  {`Rs ${Number(getAllOutstandingBlance()).toFixed(2)}`}
                </Typography>
                <div>
                  <CustomButton
                    text="Pay"
                    onClick={onOpenCollectOutstanding}
                    smallBtn
                  />
                </div>
              </div>
              <div className="blk-hor-split" />
            </>
          ) : (
            <div className="no-rec">No records available</div>
          )}
        </div>
      </CustomModal>

      <CustomModal
        open={showOutstandingCollection}
        onClose={onCloseCollectOutstanding}
        header="Pay"
        modalWidth={30}
        rightModal
      >
        <div className="scroll-80vh">
          <Grid container spacing={2} className="ph20">
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="txt-semi-bold fs14 light-grey">
                Invoice Number <span className="red-color">*</span>
              </div>
              <Select
                list={getOutstandingInvoiceList()}
                name="invoiceNumber"
                handleChange={(e) => {
                  onChangeCollectOutstanding("invoiceNumber", e?.target?.value);
                }}
                value={collectOutstandingValues?.invoiceNumber}
                helperText={collectOutstandingErrors?.invoiceNumber}
                error={!!collectOutstandingErrors?.invoiceNumber}
                multiSelectSearchCheck
              />
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="mh20">
              <div className="bil-bal-con">
                <div className="flex-row">
                  <div>
                    <Typography className="font-bold fs14 red-color">
                      Total Balance Due
                    </Typography>
                  </div>
                  <div className="flex1-end">
                    <Typography className="font-bold fs14 red-color">
                      {(Number(getAllOutstandingBlance()) ?? 0 > 0)
                        ? `Rs ${Number(getAllOutstandingBlance()).toFixed(2)}`
                        : "Nil"}
                    </Typography>
                  </div>
                </div>
              </div>
            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={6} xl={6} className="mt10">
              <CustomTextField
                label="Amount"
                name="amount"
                fullWidth
                handleChange={(e) =>
                  onChangeCollectOutstanding("amount", e?.target?.value)
                }
                value={collectOutstandingValues?.amount}
                labelTop
                helperText={collectOutstandingErrors?.amount}
                error={!!collectOutstandingErrors?.amount}
                type="number"
              />
            </Grid>

            <Grid item xs={6} sm={6} md={6} lg={6} xl={6} className="mt10">
              <div className="font-medium fs14 black2">Payment Mode</div>
              <PaymentModeDropdown
                list={[]}
                value={collectOutstandingValues?.paymentMode}
                error={!!collectOutstandingErrors?.paymentMode}
                helperText={collectOutstandingErrors?.paymentMode}
                onChange={(e) => {
                  onChangeCollectOutstanding("paymentMode", e);
                }}
                name="paymentMode"
                label=""
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <CustomTextField
                label="Collection Date"
                name="collectionDate"
                fullWidth
                handleChange={(e) =>
                  onChangeCollectOutstanding("collectionDate", e?.target?.value)
                }
                value={collectOutstandingValues?.collectionDate}
                labelTop
                mobileDate
                maxDate={new Date()}
              />
            </Grid>

            {collectOutstandingValues?.paymentMode?.value ===
            "Advance Adjustment" ? (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography className="txt-semi-bold fs14 orange5">
                  Available Balance:{" "}
                  {Number(petData?.advanceAmount)
                    ? `Rs ${Number(petData?.advanceAmount).toFixed(2)}`
                    : "Nil"}
                </Typography>
              </Grid>
            ) : null}

            <div className="flex1-end mt20">
              <div>
                <CustomButton
                  smallBtn
                  text="Pay"
                  onClick={onClickCollectOutstandingPay}
                />
              </div>
            </div>
          </Grid>
        </div>
      </CustomModal>

      <CustomModal
        open={remModVsble}
        onClose={onCloseRemMod}
        header="Schedules/Reminders"
        modal
        modalWidth={90}
        headerBold
      >
        <div className="scroll-80vh">
          <div className="rem-mod-tabs-wrap flex-row-ali-cen">
            <div
              className={`rem-mod-tab flex-row-ali-cen cursor ${
                actTab === "preventive"
                  ? "rem-mod-tab-active rem-mod-tab-preventive"
                  : ""
              }`}
              onClick={() => onChangeTab("preventive")}
            >
              <ShieldOutlinedIcon
                sx={{
                  fontSize: 18,
                  color: actTab === "preventive" ? "#1a7a4a" : AppColors.green,
                }}
              />
              <Typography
                className={`fs13 font-bold ml5 ${
                  actTab === "preventive"
                    ? "rem-mod-tab-preventive-text"
                    : "black"
                }`}
              >
                Preventive
              </Typography>
            </div>
            <div
              className={`rem-mod-tab flex-row-ali-cen cursor ${
                actTab === "diagnostics"
                  ? "rem-mod-tab-active rem-mod-tab-diagnostics"
                  : ""
              }`}
              onClick={() => onChangeTab("diagnostics")}
            >
              <BiotechOutlinedIcon
                sx={{
                  fontSize: 18,
                  color: AppColors.appPrimary,
                }}
              />
              <Typography
                className={`fs13 font-bold ml5 ${
                  actTab === "diagnostics"
                    ? "rem-mod-tab-diagnostics-text"
                    : "black"
                }`}
              >
                Diagnostics
              </Typography>
            </div>
            <div
              className={`rem-mod-tab flex-row-ali-cen cursor ${
                actTab === "procedure"
                  ? "rem-mod-tab-active rem-mod-tab-care"
                  : ""
              }`}
              onClick={() => onChangeTab("procedure")}
            >
              <MedicationOutlinedIcon
                sx={{
                  fontSize: 18,
                  color: AppColors.rose,
                }}
              />
              <Typography
                className={`fs13 font-bold ml5 ${
                  actTab === "procedure" ? "rem-mod-tab-care-text" : "black"
                }`}
              >
                Care
              </Typography>
            </div>
            <div className="flex1-end">
              {/* {actTab === "prescription" ? (
                <div className="w25Per">
                  <Select
                    list={presFilters}
                    value={presFilter}
                    handleChange={(e) => setPresFilter(e?.target?.value)}
                    name="petType"
                    select
                  />
                </div>
              ) : null} */}
              <div className="ml10">
                <CustomButton text="Add" onClick={onClickAdd} smallBtn />
              </div>
            </div>
          </div>
          {actTab === "preventive" && (
            <ReminderPreventive addVsble={addVsble} setAddVsble={setAddVsble} />
          )}
          {/* {actTab === "prescription" && (
            <ReminderPrescription
              addVsble={addVsble}
              setAddVsble={setAddVsble}
              presFilter={presFilter}
            />
          )} */}
          {actTab === "diagnostics" && (
            <ReminderDiagnostics
              addVsble={addVsble}
              setAddVsble={setAddVsble}
              apntId={apntId}
            />
          )}
          {actTab === "procedure" && (
            <ReminderProcedure addVsble={addVsble} setAddVsble={setAddVsble} />
          )}
        </div>
      </CustomModal>

      {certModVsble ? (
        <CerificatesDownloadModal
          modVsble={certModVsble}
          onCloseMod={onCloseCertMod}
        />
      ) : null}

      {/* <CustomModal
        open={certModVsble}
        onClose={onCloseCertMod}
        header="Certificates"
        modal
        modalWidth={80}
        headerBold
      >
        <div className="scroll-80vh">
          <div className="flex-row-ali-cen mh20">
            <Typography
              className={`txt-semi-bold fs12 gray4 cursor ${
                actTab === "preventive" ? "tab-grn-back" : "tab-gray-back"
              }`}
              onClick={() => onChangeTab("preventive")}
            >
              Preventive
            </Typography>
          </div>

          <Preventive setScrollable={setScrollable} />
        </div>
      </CustomModal> */}
      {admitModVisible ? (
        <InpatientAdmitPatient
          modalVisible={admitModVisible}
          onCloseMod={onCloseAdmitModal}
          modalData={{ ...apntDet, patientId: inpatData?.patientId ?? null }}
          sendToRecovery={sendToRecovery}
        />
      ) : null}

      {/* <AdmitPatient
        modalVisible={admitModVisible}
        onCloseMod={onCloseAdmitModal}
        modalData={appData?.appointment}
      /> */}

      <CustomModal
        open={coOwnerModalVisible}
        onClose={handleCoOwnModClose}
        header="Co-Owner Details"
        rightModal
        modalWidth={30}
      >
        <Grid container spacing={2} className="ph20">
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="text-bold fs14 mb5">
              Name <span className="red-color">*</span>
            </div>
            <CustomTextField
              name="name"
              fullWidth
              value={coOwnDetails?.name}
              handleChange={(e) => handleCoOwnChange("name", e?.target?.value)}
              error={coOwnErrors?.name}
              helperText={coOwnErrors?.name ? "Name is required field" : ""}
            />
          </Grid>

          <Grid item xs={6} sm={6} md={6} lg={6} xl={6} className="mb20">
            <div className="text-bold fs14 mb5">
              Email <span className="red-color">*</span>
            </div>
            <CustomTextField
              name="email"
              fullWidth
              value={coOwnDetails?.email}
              handleChange={(e) => handleCoOwnChange("email", e?.target?.value)}
              error={coOwnErrors?.email}
              helperText={coOwnErrors?.email ? "Email is required field" : ""}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6} className="mb20">
            <div className="text-bold fs14 mb5 ">
              Contact Number <span className="red-color">*</span>
            </div>
            <CustomTextField
              name="mobile"
              fullWidth
              value={coOwnDetails?.mobile}
              handleChange={(e) =>
                handleCoOwnChange("mobile", e?.target?.value)
              }
              error={coOwnErrors?.mobile}
              helperText={coOwnErrors?.mobile ? "Mobile is required field" : ""}
            />
          </Grid>

          <div className="flex1-end">
            <div>
              <CustomButton text="Save" smallBtn onClick={handleSaveCoOwner} />
            </div>
          </div>
        </Grid>
      </CustomModal>

      <CustomModal
        open={disCofrmModVsble}
        onClose={handleCloseDisCnfrm}
        header="Discharge Pet"
        modal
        modalWidth={40}
      >
        <Typography className="txt-regular fs16 ml10">
          Are you sure you want to Discharge the patient?
        </Typography>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <div className="clinic-mod-btn-pos mb10 mt15">
            <div className="mr10">
              <CustomButton
                text="Yes"
                redBtn
                onClick={handleConfirmDischarge}
                smallBtn
              />
            </div>
            <div className="ml10">
              <CustomButton text="No" onClick={handleCloseDisCnfrm} smallBtn />
            </div>
          </div>
        </Grid>
      </CustomModal>

      <CustomModal
        open={bundleModVsble}
        onClose={handleBundleclose}
        header={isAddNewBundle ? "Select Bundle" : "Active Bundle"}
        modal
        modalWidth={40}
        addBtn={!isAddNewBundle}
        onClickAdd={handleAddBundle}
      >
        <div className="scroll-60vh">
          {isAddNewBundle ? (
            <CustomTextField
              placeholder="Search"
              fullWidth
              handleChange={(e) => setBundleSearchValue(e.target.value)}
              value={bundleSearchValue}
              backgroundColor={AppColors.lightPink}
            />
          ) : null}
          {(!isAddNewBundle && petTreatmentBundles?.length > 0) ||
          (isAddNewBundle && treatmentBundles?.length > 0) ? (
            (isAddNewBundle
              ? bundleSearchValue?.length > 0
                ? treatmentBundles?.filter((bl) =>
                    bl?.bundleName
                      ?.toLowerCase()
                      ?.includes(bundleSearchValue?.toLowerCase()),
                  )
                : treatmentBundles
              : petTreatmentBundles
            )?.map((li, i) => (
              <div
                key={i}
                className={`mt10 cursor ${
                  (li?.treatmentId ?? li?.bundleId) ===
                  (selectedBundle?.treatmentId ?? selectedBundle?.bundleId)
                    ? "blue-box2"
                    : "gray-box3"
                }`}
                onClick={() => setSelectedBundle(li)}
              >
                <div className="flex-row-between-align-center">
                  <div className="flex-row-ali-cen">
                    <CustomCheckbox
                      circle
                      checked={
                        selectedBundle
                          ? (li?.treatmentId ?? li?.bundleId) ===
                            (selectedBundle?.treatmentId ??
                              selectedBundle?.bundleId)
                          : false
                      }
                    />
                    <Typography className="fs14 blue-color font-bold">
                      {li?.bundleName}
                    </Typography>
                  </div>
                  <Typography className="font-bold fs14 red12">
                    {!isAddNewBundle
                      ? "Remaining Qty: 1"
                      : `Rs ${Number(
                          getTotalEstimatedCost(li?.treatmentBundleDetails),
                        )?.toFixed(2)}`}
                  </Typography>
                </div>
                <div className="flex-row-ali-cen ph10">
                  <div className="gry-dot2" />
                  <Typography className="fs12 blue-color txt-regular ml5">
                    Type:
                  </Typography>
                  <Typography className="fs12 black20 txt-regular ml5">
                    {li?.usageType}
                  </Typography>
                </div>

                <Typography className="gray22 fs14 font-medium ph10">
                  {li?.description}
                </Typography>
              </div>
            ))
          ) : (
            <div className="no-record">No active bundles available</div>
          )}
          {selectedBundle ? (
            <div className="flex-center">
              <div className="mv20">
                <CustomButton smallBtn text="Assign" onClick={handleAssign} />
              </div>
            </div>
          ) : null}
        </div>
      </CustomModal>

      <CustomModal
        open={petModVsble}
        onClose={petModClose}
        header="Update"
        rightModal
        modalWidth={30}
      >
        <div className="scroll-80vh ph20 mt10">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="mb30">
              <CustomUpload
                uploadText="Profile Picture"
                onUploadFile={onUploadFile}
                value={petValues?.image?.previewUrl}
                profileImg
                imageHeight={140}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              {/* <div className="txt-mont fs14">
                Name <span className="red-color">*</span>
              </div> */}
              <div>
                <CustomTextField
                  name="petName"
                  fullWidth
                  handleChange={(e) =>
                    handlePetValueChange(e?.target?.value, "petName")
                  }
                  value={petValues?.petName}
                  error={!!errors.petName}
                  helperText={errors.petName}
                  label="Name "
                  required={true}
                />
              </div>
            </Grid>

            <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
              {/* <div className="txt-mont fs14">
                Pet Type <span className="red-color">*</span>
              </div> */}
              <div>
                <Select
                  list={petTypeList}
                  value={petValues?.petType}
                  handleChange={(e, value) =>
                    handlePetValueChange(value, "petType")
                  }
                  name="petType"
                  search
                  error={!!errors.petType}
                  helperText={errors.petType}
                  label="Pet Type *"
                />
              </div>
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="flex-row-ali-cen mtMin10">
                <Typography className="font-medium fs14 black">DOB</Typography>
                <span className="red-color ml2">*</span>
                <div className="ml15">
                  <CustomCheckbox
                    radio
                    name="dobType"
                    value={petValues?.dobType ?? "age"}
                    onChange={(e) =>
                      handlePetValueChange(e?.target?.value, "dobType")
                    }
                    radios={[
                      { label: "Date", value: "date" },
                      { label: "Age", value: "age" },
                    ]}
                  />
                </div>
              </div>
            </Grid>

            {petValues?.dobType === "date" ? (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <div className="mb20 mtMin10">
                  <CustomTextField
                    name="dob"
                    fullWidth
                    handleChange={(e) =>
                      handlePetValueChange(e?.target?.value, "dob")
                    }
                    value={petValues?.dob}
                    error={!!errors.dob}
                    helperText={errors.dob}
                    label="Date of Birth"
                    mobileDate
                    required
                  />
                </div>
              </Grid>
            ) : (
              <>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <div className="mb20 mtMin10">
                    <CustomTextField
                      name="dob"
                      fullWidth
                      handleChange={(e) =>
                        handlePetValueChange(e?.target?.value, "dob")
                      }
                      value={petValues?.dob}
                      error={!!errors.dob}
                      helperText={errors.dob}
                      label={`Age in ${petValues?.ageType ?? "Month"}`}
                      required
                      type="number"
                    />
                  </div>
                </Grid>
                <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                  <div className="mb20 mtMin10">
                    <Select
                      list={[
                        { name: "Month", value: "Month" },
                        { name: "Year", value: "Year" },
                      ]}
                      value={petValues?.ageType}
                      handleChange={(e) =>
                        handlePetValueChange(e?.target?.value, "ageType")
                      }
                      name="ageType"
                      select
                      error={!!errors.ageType}
                      helperText={errors.ageType}
                      label="Age Type * "
                    />
                  </div>
                </Grid>
              </>
            )}
            <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
              {/* <div className="txt-mont fs14">
                Breed <span className="red-color">*</span>
              </div> */}
              <div className="mb20">
                <Select
                  list={breedList}
                  value={petValues?.breed}
                  handleChange={(e, value) =>
                    handlePetValueChange(value, "breed")
                  }
                  name="breed"
                  search
                  error={!!errors.breed}
                  helperText={errors.breed}
                  label="Breed * "
                />
              </div>
            </Grid>

            <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
              <div className="mb20">
                <CustomTextField
                  label="Color"
                  name="color"
                  fullWidth
                  handleChange={(e) =>
                    handlePetValueChange(e?.target?.value, "color")
                  }
                  value={petValues?.color}
                  error={!!errors.color}
                  helperText={errors.color}
                />
              </div>
            </Grid>

            <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
              {/* <div className="txt-mont fs14">
                Gender
              </div> */}
              <div className="mb20">
                <Select
                  list={genderList}
                  value={petValues?.gender}
                  handleChange={(e) =>
                    handlePetValueChange(e?.target?.value, "gender")
                  }
                  select
                  error={!!errors.gender}
                  helperText={errors.gender}
                  label="Gender * "
                />
              </div>
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
              {/* <div className="txt-mont fs14">
                Reproductive Status

              </div> */}
              <div className="mb20">
                <Select
                  list={
                    petValues?.gender?.toLowerCase() === "male"
                      ? reproductiveStatusMaleList
                      : petValues?.gender?.toLowerCase() === "female"
                        ? reproductiveStatusFemaleList
                        : reproductiveStatusUnknownList
                  }
                  value={petValues?.reproductiveStatus}
                  handleChange={(e) =>
                    handlePetValueChange(e?.target?.value, "reproductiveStatus")
                  }
                  error={!!errors.reproductiveStatus}
                  helperText={errors.reproductiveStatus}
                  select
                  label="Reproductive Status "
                />
              </div>
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
              <div className="mb20">
                <CustomTextField
                  name="weight"
                  value={petValues?.weight}
                  fullWidth
                  handleChange={(e) =>
                    handlePetValueChange(e?.target?.value, "weight")
                  }
                  error={!!errors.weight}
                  helperText={errors.weight}
                  suffix={petValues?.weight !== "" ? "Kg" : ""}
                  label="Weight "
                  // mandatoryField
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
              <div className="mb20">
                <CustomTextField
                  label="Microchip Number"
                  name="rfid"
                  fullWidth
                  handleChange={(e) =>
                    handlePetValueChange(e?.target?.value, "rfid")
                  }
                  value={petValues?.rfid}
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
              {/* <div className="txt-mont fs14">Blood Group</div> */}
              <div className="mb20">
                <Select
                  list={bloodGroups}
                  value={petValues?.bloodGroup}
                  handleChange={(e, value) =>
                    handlePetValueChange(value, "bloodGroup")
                  }
                  name="bloodGroup"
                  error={!!errors.bloodGroup}
                  helperText={errors.bloodGroup}
                  search
                  label="Blood Group "
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
              {/* <div className="txt-mont fs14">Temperament</div> */}
              <div className="mb20">
                <Select
                  list={temperaments}
                  value={petValues?.temperament}
                  handleChange={(e, value) =>
                    handlePetValueChange(value, "temperament")
                  }
                  name="temperament"
                  label="Temperament"
                  error={!!errors.temperament}
                  helperText={errors.temperament}
                  search
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="flex1-end">
                <div>
                  <CustomButton text="Update" onClick={updatePet} smallBtn />
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </CustomModal>

      <CustomModal
        open={usrModVsble}
        onClose={usrModClose}
        header="Update"
        rightModal
        modalWidth={30}
      >
        <div className="scroll-80vh-new ph20 mt10">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="mt10">
                <CustomTextField
                  label="Parent Name"
                  name="userName"
                  fullWidth
                  handleChange={(e) =>
                    handleValueChange(e?.target?.value, "userName")
                  }
                  value={usrValues?.userName}
                  error={!!usrErrs.userName}
                  helperText={usrErrs.userName}
                  required={true}
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div>
                <CustomTextField
                  label="Contact Number"
                  name="userMobile"
                  fullWidth
                  handleChange={(e) =>
                    handleValueChange(e?.target?.value, "userMobile")
                  }
                  value={usrValues?.userMobile}
                  error={!!usrErrs.userMobile}
                  helperText={usrErrs.userMobile}
                />
              </div>
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div>
                <CustomTextField
                  label="Email"
                  name="email"
                  fullWidth
                  handleChange={(e) =>
                    handleValueChange(e?.target?.value, "email")
                  }
                  value={usrValues?.email}
                  error={!!usrErrs.email}
                  helperText={usrErrs.email}
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div>
                <CustomTextField
                  label="Secondary Phone Number"
                  name="secondaryMobile"
                  fullWidth
                  handleChange={(e) =>
                    handleValueChange(e?.target?.value, "secondaryMobile")
                  }
                  value={usrValues?.secondaryMobile}
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div>
                <CustomTextField
                  label="Address"
                  name="address"
                  fullWidth
                  handleChange={(e) =>
                    handleValueChange(e?.target?.value, "address")
                  }
                  value={usrValues?.address}
                  labelTop
                  multiline
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="flex1-end">
                <div>
                  <CustomButton text="Update" onClick={updateUser} smallBtn />
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </CustomModal>

      <CustomModal
        open={advancePayVsble}
        onClose={handleClosePayMod}
        header="Pay"
        rightModal
        modalWidth={30}
      >
        <div className="flex-center">
          <Card
            sx={{
              borderRadius: 1,
              padding: 2,
              borderTopColor: `${getBorderColor("paid")}`,
            }}
            className="pay-card"
          >
            <div className="maint">
              <div>
                <div className="flex-row parentcontainer">
                  <div className="flex-row  iconcontainer">
                    <AccountCircleOutlinedIcon sx={{ width: 25, height: 25 }} />
                    <Typography className="  font-bold fs14 capitalize flex-center h35">
                      {petData?.userName}
                    </Typography>
                  </div>
                </div>

                <div className="datecontainer"></div>
              </div>
            </div>
          </Card>
        </div>
        <Grid container spacing={2} className="ph20">
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="flex-row-ali-cen">
              <Typography className="font-medium fs14 green-color mt15">
                Available Balance:{" "}
                {Number(petData?.advanceAmount)
                  ? `Rs ${Number(petData?.advanceAmount).toFixed(2)}`
                  : "Nil"}
              </Typography>
              <div className="ml10"></div>
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="flex-row-ali-cen">
              <Typography className="font-medium fs14 black mb5">
                Credit Balance:
              </Typography>
              <div className="ml10">
                <CustomCheckbox
                  radio
                  value={usrValues?.paymentType}
                  onChange={(e) =>
                    handleValueChange(e?.target?.value, "paymentType")
                  }
                  radios={radioPaymentTypes}
                  defaultValue={usrValues?.paymentType}
                />
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <div className="mb20">
              <CustomTextField
                label="Amount"
                name="advanceAmount"
                fullWidth
                handleChange={(e) =>
                  handleValueChange(e?.target?.value, "advanceAmount")
                }
                value={usrValues?.advanceAmount}
                error={!!usrErrs.advanceAmount}
                helperText={usrErrs.advanceAmount}
                type="number"
              />
            </div>
          </Grid>

          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            {/* <div className="font-medium fs14 black2">Payment Mode</div> */}
            <div className="mb20">
              {/* <Select
                list={UserPaymentTypeList}
                value={usrValues?.paymentMode}
                handleChange={(e, value) =>
                  handleValueChange(value, "paymentMode")
                }
                name="paymentMode"
                error={!!usrErrs.paymentMode}
                helperText={usrErrs.paymentMode}
                search
                label="Payment Mode"
              /> */}
              <PaymentModeDropdown
                list={UserPaymentTypeList}
                value={usrValues?.paymentMode}
                onChange={(e) => handleValueChange(e, "paymentMode")}
                hideAdvancedAdjustment={
                  usrValues?.paymentType?.toLocaleLowerCase() === "collect"
                }
              />
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="mb20">
              <CustomTextField
                label="Reason"
                name="reason"
                fullWidth
                handleChange={(e) =>
                  handleValueChange(e?.target?.value, "reason")
                }
                value={usrValues?.reason}
                multiline
              />
            </div>
          </Grid>

          <div className="flex1-end mt20">
            <div>
              <CustomButton text="Pay" onClick={handlePay} smallBtn />
            </div>
          </div>
        </Grid>
      </CustomModal>

      <CustomModal
        open={assignVetModVisible}
        onClose={onCloseAssignVetMod}
        header={
          clinicDetails?.id === apntDet?.doctorId &&
          !checkIsVet(profile?.id) &&
          !apntDet?.facilityId
            ? "Select Vet and Facility"
            : !apntDet?.facilityId
              ? "Select Facility"
              : "Select Vet"
        }
        modal
        modalWidth={30}
      >
        <div className="mh10">
          {clinicDetails?.id === apntDet?.doctorId &&
          !checkIsVet(profile?.id) ? (
            <div>
              <Select
                list={
                  apntDet?.serviceType === "Grooming" ||
                  apntDet?.serviceType === "Lab Tests" ||
                  apntDet?.serviceType === "Radiology Tests"
                    ? getOthersByType(apntDet?.serviceType)
                    : apntDet?.serviceType === "Others"
                      ? getAllClinicUserList()
                      : getVetList()
                }
                handleChange={(e, value) =>
                  onAssignVetChange("vet", value, "error")
                }
                name="vet"
                label="Vet Name *"
                search
                value={assignVetvalues?.vet}
                error={!!assignVetvalues?.error}
                helperText={
                  assignVetvalues?.error ? "Vet Name is required field" : ""
                }
              />
            </div>
          ) : null}
          {!apntDet?.facilityId ? (
            <div
              className={
                clinicDetails?.id === apntDet?.doctorId &&
                !checkIsVet(apntDet?.doctorId) &&
                !checkIsVet(profile?.id)
                  ? "mt15"
                  : ""
              }
            >
              <Select
                list={getFacilitiesByType(apntDet?.serviceType)}
                handleChange={(e, value) =>
                  onAssignVetChange("facility", value, "facilityErr")
                }
                name="facility"
                label="Facility *"
                search
                value={assignVetvalues?.facility}
                error={!!assignVetvalues?.facilityErr}
                helperText={
                  assignVetvalues?.facilityErr
                    ? "Facility is required field"
                    : ""
                }
              />
            </div>
          ) : null}
          <div className="flex-center mv20">
            <div>
              <CustomButton text="Save" onClick={onAssignVet} smallBtn />
            </div>
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={viewTreadsVsble}
        onClose={() => setViewTreadsVsble(false)}
        header="Vital Trends"
        modal
        modalWidth={80}
      >
        <Box sx={{ px: 2.5, pb: 2.5 }}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
            flexWrap="wrap"
            gap={1.5}
          >
            <Typography
              variant="subtitle1"
              fontWeight={600}
              sx={{ color: "#2C2C49" }}
            >
              {selectedVitalTab} Trend
            </Typography>
            <ToggleButtonGroup
              value={selectedVitalTab}
              exclusive
              onChange={(_, val) => val && setSelectedVitalTab(val)}
              size="small"
              sx={{
                backgroundColor: "#f0f2f5",
                borderRadius: "12px",
                "& .MuiToggleButtonGroup-grouped": {
                  borderRadius: "7px",
                  borderColor: "transparent",
                  color: "#333",
                  transition: "none",
                  textTransform: "none",
                  px: 2,
                  "&.Mui-selected": {
                    backgroundColor: "#005EB8",
                    color: "#fff",
                  },
                },
              }}
            >
              {vitalTrendTabs.map((tab) => (
                <ToggleButton key={tab} value={tab}>
                  {tab}
                </ToggleButton>
              ))}
            </ToggleButtonGroup>
          </Box>
          <Box
            sx={{
              backgroundColor: "#FAFBFC",
              borderRadius: "8px",
              padding: "16px",
              border: "1px solid #E9ECEF",
              minHeight: 320,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {vitalTrendChartData?.length > 0 ? (
              <Box sx={{ width: "100%" }}>
                <Chart
                  key={selectedVitalTab}
                  options={vitalTrendChartOptions}
                  series={vitalTrendChartSeries}
                  type="line"
                  height={350}
                />
              </Box>
            ) : (
              <Typography
                sx={{
                  color: "#636363",
                  fontSize: "14px",
                  fontWeight: 500,
                  fontFamily: "Montserrat",
                }}
              >
                No records available
              </Typography>
            )}
          </Box>
        </Box>
      </CustomModal>
      <CustomModal
        open={shortcutModVsble}
        onClose={onCloseShortcutModal}
        header="Memo/Records"
        modal
        modalWidth={90}
      >
        <div className="mt10 mh20 mb10">
          <CustomTextField
            label="Memo"
            name="memo"
            fullWidth
            multiline
            labelTop
            value={shortcutMemo}
            handleChange={(e) => {
              setShortcutMemo(e?.target?.value);
              setShortcutError("");
            }}
            placeholder="Enter memo"
          />
          <div className="mt15">
            {/* <Typography className="fs13 font-medium mb5">Upload files</Typography> */}
            {shortcutFiles?.length > 0 ? (
              <FilesWithCloseButton
                files={shortcutFiles}
                onClickFile={(i) => handleRemoveShortcutFile(i)}
              />
            ) : null}
            <CustomUpload
              onUploadFile={onUploadShortcutFile}
              multipleNew
              multiFiles
            />
          </div>
          {shortcutError ? (
            <div className="flex-center">
              <Typography color="error" className="fs12 mt5">
                {shortcutError}
              </Typography>
            </div>
          ) : null}
          <div className="flex1-center mb10 mt15">
            <div>
              <CustomButton
                text="Submit"
                smallBtn
                onClick={handleShortcutSubmit}
              />
            </div>
          </div>
        </div>
      </CustomModal>
      {billPreviewModVsble ? (
        <BillingPreview
          selectedBill={billDetails}
          modVsble={billPreviewModVsble}
          onClosePreview={() => {
            dispatch(setBillDetails(null));
            setBillPreviewModVsble(false);
          }}
          billsToShow={[
            billDetails?.type === "Clinic"
              ? "treatment"
              : billDetails?.type === "Pharmacy"
                ? "pharmacy"
                : "petshop",
          ]}
        />
      ) : null}
    </>
  );
};

export default CommonClinicPetDetails;
